{
  "dynamicRounds": {
    "queue": {
      "title": "Dynamic Round Approvals",
      "raise": "Raise Dynamic Round",
      "review": "Review",
      "cancel": "Withdraw",
      "empty": "No pending dynamic round requests.",
      "confirmCancel": "Are you sure you want to withdraw this request?",
      "cancelSuccess": "Request withdrawn.",
      "cancelError": "Failed to withdraw the request.",
      "pendingTitle": "Pending Dynamic Rounds"
    },
    "raise": {
      "title": "Raise Dynamic Round",
      "submit": "Submit Request",
      "success": "Dynamic round request submitted.",
      "error": "Failed to submit the request."
    },
    "review": {
      "title": "Review Dynamic Round Request",
      "approveTab": "Approve",
      "rejectTab": "Reject",
      "approve": "Approve & Schedule",
      "reject": "Reject",
      "approveSuccess": "Dynamic round approved and scheduled.",
      "approveError": "Failed to approve the request.",
      "rejectSuccess": "Request rejected.",
      "rejectError": "Failed to reject the request."
    },
    "fields": {
      "node": "Area / Node",
      "source": "Trigger Source",
      "round": "Round",
      "recommendedRound": "Recommended Round",
      "noRound": "None",
      "shift": "Shift",
      "businessDate": "Business Date",
      "assignGroup": "Assign Operational Position",
      "noGroup": "Unassigned",
      "priority": "Priority",
      "details": "Details",
      "detailsPlaceholder": "Describe why this round is needed",
      "reviewNotes": "Review Notes",
      "rejectReason": "Rejection Reason",
      "requestedAt": "Requested",
      "approvalDue": "Approval Due"
    }
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "done": "Done",
    "clear": "Clear",
    "clearFilter": "Clear filter",
    "expand": "Expand",
    "dismiss": "Dismiss",
    "pending": "Pending",
    "yes": "Yes",
    "no": "No",
    "pass": "Pass",
    "fail": "Fail",
    "edit": "Edit",
    "delete": "Delete",
    "remove": "Remove",
    "create": "Create",
    "confirm": "Confirm",
    "actions": "Actions",
    "dragToReorder": "Drag to reorder",
    "showingOf": "Showing {{shown}} of {{total}}",
    "notice": "Notice",
    "status": "Status",
    "sort": "Sort",
    "confirmDelete": "Are you sure you want to delete this item?",
    "genericErrorMessage": "An unexpected error occurred. Please try again.",
    "notImplementedYet": "{{feature}} is not implemented yet.",
    "soon": "Soon",
    "savedSuccessfully": "Saved successfully.",
    "deletedSuccessfully": "Deleted successfully.",
    "approve": "Approve",
    "reject": "Reject",
    "view": "View",
    "download": "Download",
    "print": "Print",
    "exportPdf": "Export to PDF",
    "days": "days",
    "search": "Search...",
    "searchLabel": "Search",
    "collapseAll": "Collapse all",
    "expandAll": "Expand all",
    "noResults": "No results found.",
    "selectionRequired": "Please select a value.",
    "notApplicable": "Global",
    "any": "Any",
    "back": "Back",
    "loading": "Loading...",
    "noData": "No data available.",
    "refresh": "Refresh",
    "moreCount": "+{{count}} more",
    "messages": {
      "saved": "Saved successfully."
    },
    "richText": {
      "textStyle": "Text style",
      "style": "Style",
      "normal": "Normal",
      "heading1": "Heading 1",
      "heading2": "Heading 2",
      "heading3": "Heading 3",
      "quote": "Quote",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "strikethrough": "Strikethrough",
      "textColor": "Text color",
      "bulletList": "Bullet List",
      "numberedList": "Numbered List",
      "insertLink": "Insert Link",
      "insertImage": "Insert Image",
      "clearFormatting": "Clear formatting",
      "enterLinkUrl": "Enter the link URL (https://…)"
    },
    "clearSearch": "Clear search",
    "resizeColumn": "Resize column",
    "minUnit": "min",
    "minutesShort": "{{count}} min",
    "megabytes": "{{size}} MB",
    "removeItem": "Remove {{name}}",
    "expandItem": "Expand {{name}}",
    "collapseItem": "Collapse {{name}}"
  },
  "app": {
    "title": "Ops Hub",
    "logout": "Logout",
    "darkMode": "Dark mode",
    "lightMode": "Light mode",
    "howToVideo": "How-to video for this page",
    "howToVideos": "How-to videos for this page",
    "videoInstruction": "Video instruction",
    "search": "Search...",
    "forms": {
      "create": "Create",
      "cancel": "Cancel",
      "save": "Save",
      "labels": {
        "businessUnit": "Business Unit",
        "placeholderBusinessUnit": "Select Business Unit"
      }
    },
    "toggleMenu": "Toggle menu",
    "copyright": "{{year}} Chevron Corporation. All rights reserved.",
    "language": "Language"
  },
  "helpVideos": {
    "title": "How-to videos",
    "search": "Search how-to videos",
    "noResults": "No how-to video matches your search.",
    "chapters": "Chapters",
    "openInSharePoint": "Open in SharePoint",
    "loadError": "This video could not be loaded. Try again later.",
    "askPlaceholder": "Search or ask a question",
    "asking": "Looking for videos that answer your question…",
    "aiSuggestions": "Suggested by AI",
    "keywordMatches": "Videos that mention your words",
    "noAnswer": "No how-to video answers this question yet.",
    "askError": "The search isn't available right now. Try again later.",
    "allVideos": "All how-to videos",
    "relatedVideos": "Related videos",
    "otherVideos": "More videos",
    "nowPlaying": "Now playing",
    "thisPage": "This page",
    "noVideos": "No how-to videos have been published yet."
  },
  "nav": {
    "home": "Home",
    "ord": "ORD",
    "dynamicTasks": "Dynamic Tasks",
    "startOfShift": "Start of Shift",
    "shiftLog": "Shift Log",
    "shiftTurnover": "Shift Turnover",
    "roundHub": "Task Studio",
    "admin": "Admin",
    "adminHome": "Admin Home",
    "reports": "Reports",
    "dashboard": "Dashboard",
    "hierarchy": "Hierarchy",
    "operationalPositions": "Operational Positions",
    "roles": "System Roles",
    "rounds": "Rounds Builder",
    "changeRequests": "Change Requests",
    "changeRequestWorkbench": "Change Workbench",
    "roundStatusDashboard": "Round Status Dashboard",
    "scheduling": "Scheduling",
    "execution": "Execution",
    "exceptions": "Exceptions",
    "taskManagement": "Task Management",
    "shiftHandover": "Shift Handover",
    "shiftNotes": "Shift Notes",
    "notesHistory": "Notes History",
    "pendingApprovals": "Pending Approvals",
    "areaRollup": "Area Roll-up",
    "operatorHandover": "Operator Handover",
    "accessRequests": "Access Requests",
    "equipment": "Equipment",
    "collapse": "Collapse",
    "expand": "Expand",
    "myRounds": "My Rounds"
  },
  "tilesDashboard": {
    "title": "Dashboard",
    "externalBadge": "External",
    "comingSoon": "Coming Soon",
    "integrationPending": "Integration pending",
    "roundsHub": {
      "title": "Rounds Hub",
      "openRounds": "Open Rounds",
      "completedRounds": "Completed Rounds"
    },
    "tasks": {
      "title": "Tasks",
      "completed": "Completed",
      "expiringSoon": "Expiring Soon",
      "missed": "Missed / Dynamic Tasks"
    },
    "dynamicTasks": {
      "title": "Active Dynamic Tasks",
      "viewAll": "View All Dynamic Tasks",
      "noTasks": "No active dynamic tasks.",
      "detected": "Detected",
      "agedPrefix": "Aged",
      "shiftOne": "{{count}} Shift",
      "shiftOther": "{{count}} Shifts"
    },
    "eventLog": {
      "title": "Event Log",
      "viewFullLog": "View Full Log",
      "date": "Date",
      "category": "Category",
      "createdBy": "Created by",
      "description": "Description",
      "noEntries": "No recent event log entries."
    },
    "permitsBcp": {
      "title": "Permits/BCP",
      "active": "Active",
      "closed": "Closed"
    },
    "alarmManagement": {
      "title": "Alarm Management",
      "outOfService": "Out of Service",
      "badProcessValues": "Bad Process Values",
      "shelvedAlarms": "Shelved Alarms"
    },
    "cmmsEam": {
      "title": "CMMS/EAM",
      "approvedWorkRequests": "Approved Work Requests",
      "submittedWorkRequests": "Submitted Work Requests"
    }
  },
  "planningOptimizer": {
    "title": "Planning Optimizer",
    "subtitle": "Plan, prioritize and optimize field activities.",
    "filters": {
      "date": "Date",
      "status": "Status",
      "search": "Search activities",
      "prioritySort": "Priority sort",
      "hideEmptyLocations": "Hide empty locations",
      "locations": "{{count}} location(s)",
      "level": "Level {{level}}",
      "all": "All"
    },
    "views": {
      "label": "View",
      "hierarchy": "Hierarchy",
      "tasks": "Activities"
    },
    "status": {
      "all": "All statuses",
      "notStarted": "Not Started",
      "inProgress": "In Progress",
      "completed": "Completed",
      "missed": "Missed",
      "paused": "Paused",
      "cancelled": "Cancelled"
    },
    "actions": {
      "addTask": "Add Activity",
      "addNote": "Add Note",
      "viewNotes": "View Notes",
      "shiftNotes": "Shift Notes",
      "moreActions": "More actions",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "cancelActivity": "Cancel Activity",
      "keepActivity": "Keep Activity",
      "complete": "Complete",
      "reopen": "Reopen"
    },
    "columns": {
      "location": "Location / Pad",
      "task": "Activity",
      "taskType": "Type",
      "asset": "Asset",
      "well": "Well",
      "readingDateTime": "Reading Date/Time",
      "tasks": "Activities",
      "priority": "Priority",
      "estTime": "Est. Time",
      "progress": "Progress",
      "actions": "Actions",
      "status": "Status",
      "due": "Due",
      "complete": "Complete"
    },
    "tasks": {
      "empty": "No activities for the selected locations and day.",
      "critical": "Critical operator activity",
      "minutes": "{{count}} min",
      "summary": "{{count}} activity(ies) · {{minutes}} min planned"
    },
    "totals": {
      "activities": "Total activities",
      "plannedTime": "Planned time"
    },
    "schedule": {
      "asOf": "Schedule as of",
      "asOfHint": "When the activity schedule was last pulled from Databricks.",
      "notImported": "Schedule not imported yet",
      "lateAdditions": "{{count}} added after {{time}}",
      "lateAdditionHint": "Added after {{time}}"
    },
    "refresh": {
      "arrived": "{{count}} new activity(ies) added.",
      "new": "New",
      "newCount": "{{count}} new",
      "newHint": "Added since you opened this page. Opening the activity clears this mark.",
      "updated": "Updated",
      "updatedHint": "When this page last read the activities. It also refreshes on its own every 10 minutes.",
      "now": "Refresh activities"
    },
    "activities": {
      "estTotal": "{{count}} Est mins",
      "count": "{{count}} Activities",
      "heading": "Activities ({{count}})",
      "none": "No activities added yet",
      "noneHint": "Click \"Add Activity\" to create an activity for this location."
    },
    "hierarchy": {
      "noLocations": "Choose a location above to start planning."
    },
    "drawer": {
      "title": "Activity execution"
    },
    "execution": {
      "comments": "Comments",
      "commentsPlaceholder": "e.g., Valve was already isolated on arrival; no action needed.",
      "editTask": "Edit Activity",
      "doneEditing": "Done editing",
      "markComplete": "Mark complete",
      "history": "Activity History",
      "equipmentStatus": "Status",
      "addAttachment": "Add Attachment",
      "noEquipment": "No equipment linked to this activity",
      "noEquipmentOrWell": "No equipment or well linked to this activity",
      "frozenHint": "Reopen this activity before editing it.",
      "cancelledHint": "This activity was cancelled. It can no longer be edited or completed.",
      "readOnlyHint": "Your operational position has read-only access to planning.",
      "lastUpdated": "Updated by {{by}} on {{at}}",
      "completedByAt": "Completed by {{by}} on {{at}}",
      "saving": "Saving…",
      "saved": "Saved"
    },
    "notes": {
      "empty": "No shift notes for this location.",
      "noShift": "Start a shift to see notes."
    },
    "progress": {
      "summary": "{{done}} of {{total}} complete"
    },
    "complete": {
      "reopen": "Reopen activity",
      "confirmReopen": "Reopen \"{{title}}\"? It will no longer count as complete. Its comments are kept."
    },
    "nodePicker": {
      "title": "Select Hierarchy Nodes",
      "search": "Search locations",
      "selectAll": "Select all shown",
      "clear": "Clear",
      "apply": "Apply",
      "noMatches": "No locations match your search.",
      "selectedCount": "{{count}} selected"
    },
    "addNote": {
      "title": "Add Shift Note",
      "noActiveShift": "Start a shift to add notes."
    },
    "dialog": {
      "createTitle": "Add Activity",
      "editTitle": "Edit Activity"
    },
    "fields": {
      "location": "Location",
      "title": "Activity title",
      "taskType": "Activity Type",
      "instructions": "Instructions",
      "position": "Operational Position",
      "shift": "Shift",
      "priority": "Priority",
      "estimatedMinutes": "Estimated time (min)",
      "actualMinutes": "Actual time (min)",
      "createdBy": "Activity created by",
      "completedBy": "Activity completed by",
      "completedOn": "Completion time",
      "enterRecord": "Enter record to EC",
      "enterRecordPlaceholder": "Reading",
      "enterRecordSend": "Send to EC",
      "enterRecordTarget": "{{eventType}} · {{attribute}} · books against {{date}}",
      "enterRecordLastSent": "Last sent {{value}} on {{date}}",
      "enterRecordNotConfigured": "Energy Components is not enabled for this business unit.",
      "enterRecordFrozen": "Reopen the activity to send a reading.",
      "enterRecordSuccess": "Reading sent to Energy Components.",
      "enterRecordFailed": "Energy Components rejected the reading.",
      "enterRecordDuplicateTitle": "Reading already exists",
      "enterRecordDuplicateMessage": "Energy Components already holds a reading for {{date}}. Replace it?",
      "enterRecordUnsentTitle": "Reading not sent",
      "enterRecordUnsentMessage": "This activity has an Energy Components reading that has not been sent. Completing it will block sending until the activity is reopened. Complete anyway?",
      "enterRecordSendFailed": "Not recorded in Energy Components: sending {{value}} on {{date}} failed. Press Send to try again.",
      "enterRecordSendFailedGeneric": "Not recorded in Energy Components: the last send failed. Press Send to try again.",
      "enterRecordFailedTitle": "Reading not recorded in EC",
      "enterRecordFailedCompleteMessage": "The last send of this activity's reading to Energy Components failed, so EC does not have it. Completing the activity will block sending until it is reopened. Complete anyway?",
      "enterRecordKeptExisting": "Energy Components already holds a reading for {{date}} that was not sent from OpsHub. It was kept.",
      "responseType": "Response type",
      "evidenceType": "Evidence",
      "noEvidence": "None",
      "isRequired": "Required",
      "isCritical": "Critical operator task",
      "enterRecordSending": "Sending to EC…",
      "enterRecordOptional": "Optional",
      "enterRecordSentNotCompleted": "Reading sent, but the activity was not completed. {{reason}}",
      "ecAttributes": {
        "BRADEN_PRESS": "Bradenhead",
        "CASING_PRESS_1ST_INTM": "Intermediate casing 1"
      }
    },
    "taskCategories": {
      "Workflow": "Workflow",
      "Routine": "Routine",
      "UserAdded": "User Added",
      "SystemAdded": "System Added",
      "WorkOrder": "Work Order"
    },
    "taskCategoryAbbr": {
      "Workflow": "WF",
      "Routine": "ORD",
      "UserAdded": "UA",
      "SystemAdded": "SA",
      "WorkOrder": "WO"
    },
    "responseTypes": {
      "booleanYesNo": "Yes / No",
      "passFail": "Pass / Fail",
      "numericInput": "Numeric",
      "textInput": "Text",
      "signature": "Signature",
      "photoCapture": "Photo"
    },
    "evidenceTypes": {
      "photo": "Photo",
      "gps": "GPS coordinate",
      "nfc": "NFC",
      "qr": "QR code",
      "barcode": "Barcode",
      "signature": "Signature"
    },
    "messages": {
      "created": "Activity created.",
      "updated": "Activity updated.",
      "deleted": "Activity deleted.",
      "confirmDelete": "Delete \"{{title}}\"? This cannot be undone.",
      "cancelled": "Activity cancelled.",
      "confirmCancel": "Cancel \"{{title}}\"? It stays on the board as Cancelled, with its history, but can no longer be edited or completed. This cannot be undone."
    },
    "errors": {
      "loadFailed": "Could not load activities.",
      "loadTaskFailed": "Could not open the activity editor.",
      "activityNotFound": "That activity is no longer available. It may have been deleted, or you may not have access to its location.",
      "loadExecutionFailed": "Could not load this activity's execution record.",
      "loadNotesFailed": "Could not load shift notes.",
      "saveFailed": "Could not save the activity.",
      "deleteFailed": "Could not delete the activity.",
      "cancelFailed": "Could not cancel the activity.",
      "completionFailed": "Could not update completion."
    },
    "validation": {
      "titleRequired": "Activity title cannot be blank.",
      "shiftRequired": "This position works more than one shift. Choose one.",
      "priorityRange": "Priority must be a whole number from 0 to {{max}}.",
      "estimatedRange": "Estimated time must be from 1 to {{max}} minutes (7 days).",
      "actualRange": "Actual time must be from 0 to {{max}} minutes (7 days)."
    }
  },
  "taskManagement": {
    "title": "Task Management",
    "tabs": {
      "overview": "Overview",
      "planning": "Planning Optimizer",
      "executions": "Executions",
      "dynamicTasks": "Dynamic Tasks",
      "reviewQueue": "Review Queue",
      "analytics": "Analytics",
      "history": "History"
    },
    "context": {
      "select": "Select work context",
      "change": "Change",
      "none": "Select a hierarchy node and shift to view your tasks.",
      "node": "Node",
      "shift": "Shift"
    },
    "stats": {
      "total": "Total",
      "completed": "Completed",
      "inProgress": "In Progress",
      "notStarted": "Not Started",
      "missed": "Missed",
      "dynamicTasks": "Dynamic Tasks",
      "completion": "Completion"
    },
    "roundsTabs": {
      "scheduled": "Scheduled Rounds",
      "dynamic": "Dynamic Rounds",
      "all": "All Rounds"
    },
    "rounds": {
      "roundName": "Round Name",
      "type": "Type",
      "areaUnit": "Area / Unit",
      "group": "Operational Position",
      "status": "Status",
      "due": "Due",
      "operator": "Operator",
      "unassigned": "—",
      "empty": "No rounds for the selected context."
    },
    "approvals": {
      "title": "Pending Dynamic Round Approvals",
      "note": "Approval actions require Supervisor (R-06) privileges.",
      "request": "Request",
      "trigger": "Trigger",
      "area": "Area",
      "priority": "Priority",
      "requested": "Requested",
      "status": "Status",
      "exception": "Exception",
      "empty": "No items awaiting acknowledgement or approval.",
      "page": "Page"
    },
    "dynamic": {
      "title": "Dynamic Tasks",
      "stats": {
        "total": "Total",
        "critical": "Critical",
        "high": "High",
        "medium": "Medium",
        "low": "Low",
        "unresolved": "Unresolved",
        "resolved": "Resolved"
      },
      "filters": {
        "allSeverities": "All Severities",
        "allAreas": "All Areas",
        "allStatus": "All Status",
        "allDetectionTypes": "All Detection Types"
      },
      "columns": {
        "severity": "Severity",
        "title": "Title",
        "area": "Area",
        "operator": "Operator",
        "detected": "Detected",
        "age": "Age",
        "status": "Status"
      },
      "unassigned": "Unassigned",
      "empty": "No dynamic tasks for the selected context."
    }
  },
  "shiftContext": {
    "noActiveShift": "No active shift",
    "selectPosition": "Select position",
    "user": "User",
    "operationalPosition": "Operational Position",
    "location": "Location",
    "shift": "Shift",
    "date": "Date",
    "startShift": "Start Shift",
    "endShift": "End Shift",
    "switchPosition": "Switch Position",
    "shiftStarted": "Shift started",
    "shiftStartFailed": "Could not start shift",
    "shiftEnded": "Shift ended",
    "positionSwitched": "Operational position switched",
    "noPositions": "No operational positions assigned",
    "noShiftPositions": "None of your positions work a shift",
    "noShiftAccess": "No shift access",
    "menuHint": "Shift details and actions",
    "endShiftConfirm": "End your shift? The app returns to read-only mode.",
    "switchPositionConfirm": "Switch operational position? Unsaved work on this screen may be lost.",
    "allBusinessUnits": "All Business Units"
  },
  "dashboardConfig": {
    "settings": {
      "title": "Customize {{widget}}",
      "widgetTitle": "Title",
      "widgetTitleHint": "Leave blank to use the default title.",
      "columns": "Pop-out Columns",
      "columnsHint": "Drag to reorder. Untick a column to hide it, or type a header to rename it.",
      "columnHeader": "Header",
      "tags": "PI Tags",
      "tagsHint": "Search the PI tag catalog or type a tag name, then choose how each tag is displayed. Drag to reorder.",
      "tagSearch": "PI tag",
      "addTag": "Add Tag",
      "removeTag": "Remove",
      "tagLabel": "Label",
      "tagUnit": "Unit",
      "tagGroup": "Group",
      "tagTarget": "Target",
      "tagDisplays": "Display",
      "noTags": "No PI tags configured. The widget shows its default metrics.",
      "maxTags": "A widget can show at most {{max}} PI tags.",
      "applyHint": "Changes take effect when you save the layout.",
      "reset": "Reset to Defaults",
      "apply": "Apply",
      "display": {
        "Value": "Value",
        "Trend": "Trend",
        "Average": "Average",
        "Minimum": "Minimum",
        "Maximum": "Maximum"
      }
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "shiftNoteSaved": "Shift note saved",
    "noData": "No data available",
    "integrationPending": "Integration pending",
    "notConnected": "Not connected",
    "sampleData": "Sample data",
    "sampleDataHint": "Made-up figures for demonstration. This environment is not connected to the source system.",
    "expand": "Expand",
    "collapse": "Collapse",
    "openSourceSystem": "Open source system",
    "openDetails": "Open details",
    "needsAttention": "Needs Attention",
    "nothingNeedsAttention": "Nothing needs attention",
    "attentionMore": "+{{count}} more",
    "complete": "complete",
    "roundsBar": "Rounds",
    "roundsDone": "{{done}} / {{total}} completed · {{active}} in progress",
    "timeBudget": "Planned time left",
    "timeBudgetLeft": "planned / {{remaining}}h left",
    "scheduledRounds": "Scheduled this shift",
    "activeExecutions": "In progress",
    "tiles": {
      "Round": "active · {{scheduled}} scheduled",
      "SimpleTask": "planned",
      "Permit": "active · {{closed}} closed this shift",
      "Bypass": "active",
      "Alarm": "critical",
      "Cmms": "submitted this shift",
      "Production": "units",
      "OperationalPositions": "positions · {{people}} active this shift"
    },
    "chips": {
      "criticalOverdue": "{{count}} critical overdue",
      "roundsOverdue": "{{count}} overdue",
      "activitiesOverdue": "{{count}} overdue",
      "alarmsOutOfService": "{{count}} out of service",
      "bypassAging": "{{count}} aging",
      "productionBelowTarget": "{{count}} below target",
      "positionsVacant": "{{count}} with no one active",
      "productionValuesBelowTarget": "{{count}} below target"
    },
    "attention": {
      "criticalOverdue": "{{count}} critical rounds overdue",
      "roundsOverdue": "{{count}} rounds overdue",
      "activitiesOverdue": "{{count}} activities overdue",
      "alarmsOutOfService": "{{count}} alarms out of service",
      "alarmsShelved": "{{count}} alarms shelved",
      "bypassAging": "{{count}} bypasses aging > 72h",
      "productionBelowTarget": "{{count}} production units below target",
      "positionsVacant": "{{count}} positions with no one active this shift",
      "alarmsBadValues": "{{count}} instruments with bad values",
      "productionValuesBelowTarget": "{{count}} production values below target"
    },
    "widgets": {
      "Task": {
        "title": "Tasks",
        "assigned": "assigned",
        "roundsAssigned": "{{count}} rounds",
        "completed": "completed",
        "inProgress": "in progress",
        "notStarted": "not started",
        "critical": "Critical",
        "overdue": "overdue",
        "skipped": "skipped",
        "totalTasks": "Total tasks",
        "criticalTasks": "Critical tasks",
        "remaining": "Remaining",
        "round": "Round",
        "due": "Due"
      },
      "SimpleTask": {
        "title": "Activities",
        "activities": "planned activities",
        "completed": "completed",
        "inProgress": "in progress",
        "notStarted": "not started",
        "overdue": "overdue",
        "totalActivities": "Total activities",
        "plannedHours": "Activity time (hrs)",
        "remaining": "Remaining",
        "plannedTime": "Planned time left",
        "hoursSuffix": "h",
        "activity": "Activity",
        "location": "Location",
        "planned": "Planned",
        "due": "Due",
        "openPlanner": "Open Planning Optimizer"
      },
      "Round": {
        "title": "Rounds",
        "active": "Active",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "round": "Round",
        "progress": "Progress",
        "currentStep": "Current Step",
        "hub": "Open Round Hub"
      },
      "Bypass": {
        "title": "Bypasses (BCP)",
        "active": "Active",
        "aging": "Aging (72h)",
        "returned": "Returned",
        "reference": "Reference",
        "equipment": "Equipment",
        "age": "Age",
        "description": "Description",
        "applied": "Applied"
      },
      "Permit": {
        "title": "Permits",
        "active": "Active",
        "closed": "Closed this shift",
        "number": "Permit",
        "type": "Type",
        "permitNumber": "Permit #",
        "permitTitle": "Title",
        "location": "Location",
        "issued": "Issued"
      },
      "Alarm": {
        "title": "Alarms",
        "critical": "critical activations",
        "outOfService": "out of service",
        "shelved": "shelved",
        "topTen": "Top 10 %",
        "tag": "Tag",
        "activations": "Activations",
        "contribution": "Contribution",
        "description": "Description",
        "priority": "Priority",
        "state": "State",
        "topTenList": "Top 10 alarms",
        "stats": {
          "critical": "Critical",
          "outOfService": "Out of service",
          "shelved": "Shelved",
          "badValues": "Bad values",
          "topTen": "Top 10"
        }
      },
      "Cmms": {
        "title": "Work Orders",
        "submitted": "submitted this shift",
        "newWorkRequest": "New Work Request",
        "reference": "Reference",
        "description": "Description",
        "equipment": "Equipment",
        "submittedAt": "Submitted",
        "submittedBy": "Submitted by",
        "submittedThisShift": "Submitted this shift"
      },
      "Production": {
        "title": "Production",
        "entities": "Units",
        "avg": "Avg",
        "min": "Min",
        "max": "Max",
        "target": "Target"
      },
      "OperationalPositions": {
        "title": "Operational Positions",
        "positions": "positions",
        "people": "{{count}} assigned",
        "covered": "covered",
        "unassigned": "unassigned",
        "more": "+{{count}} more",
        "position": "Position",
        "location": "Location",
        "onShift": "Active this shift",
        "noOneOnShift": "No one active this shift",
        "selected": "Selected",
        "manage": "Manage positions",
        "noShift": "No shift is in progress, so no one is shown as active."
      },
      "ProcedureHub": {
        "title": "Procedures",
        "summary": "{{completed}} completed this shift · {{active}} in progress",
        "completedThisShift": "completed this shift",
        "inProgress": "in progress",
        "noneInProgress": "No procedures in progress.",
        "procedure": "Procedure",
        "progress": "Progress",
        "steps": "{{done}} / {{total}} steps",
        "performedBy": "Performed by",
        "status": {
          "InProgress": "In progress",
          "Completed": "Completed"
        }
      },
      "ShiftNote": {
        "title": "Shift Notes",
        "count": "notes this shift",
        "placeholder": "Type your notes. Leave a blank line between notes.",
        "hint": "Separate notes with a blank line.",
        "willAdd": "{{count}} note(s) will be added",
        "save": "Add Notes",
        "classify": "Auto-classify",
        "classifying": "Classifying...",
        "classified": "{{count}} note(s) classified and added",
        "added": "{{count}} note(s) added",
        "none": "No notes yet this shift.",
        "more": "+{{count}} more",
        "viewAll": "View All Notes",
        "noShift": "Start a shift to capture notes."
      },
      "AiSummary": {
        "title": "AI Situational Awareness Summary",
        "notEnabled": "AI summary is not enabled for this asset yet."
      },
      "NeedsAttention": {
        "title": "Needs Attention"
      }
    },
    "welcome": "Welcome",
    "activeRounds": "Active Rounds",
    "openExceptions": "Open Exceptions",
    "pendingHandovers": "Pending Handovers",
    "notifications": "Notifications",
    "total": "Total",
    "critical": "Critical",
    "escalated": "Escalated",
    "executionSummary": "Execution Summary",
    "completionRate": "Completion Rate",
    "topExceptions": "Top Open Exceptions",
    "hoursOpen": "Hours Open",
    "completed": "Completed",
    "inProgress": "In Progress",
    "missed": "Missed",
    "notStarted": "Not Started",
    "completedLate": "Completed Late",
    "viewAll": "View All",
    "ioc": {
      "noData": "No dashboard data available.",
      "overallCompletion": "Overall Completion",
      "openExceptions": "Open Exceptions",
      "criticalExceptions": "Critical Exceptions",
      "areaOverview": "Area Overview",
      "completion": "Completion",
      "rounds": "Rounds",
      "exceptions": "Exceptions",
      "shifts": "Active Shifts",
      "noAreas": "No areas assigned."
    },
    "customize": "Customize Dashboard",
    "edit": {
      "title": "Customizing dashboard",
      "layoutFor": "Layout for",
      "addWidget": "Add Widget",
      "reset": "Reset to Default",
      "save": "Save Layout",
      "unsaved": "Unsaved changes",
      "hint": "Drag widgets to rearrange them, and use ⋮ on a widget to resize, customize or remove it. Widgets show live data for your current position.",
      "empty": "This layout has no widgets. Use Add Widget to place one.",
      "dragHandle": "Drag to move",
      "widgetMenu": "Widget options",
      "customizeWidget": "Customize",
      "width": "Width",
      "widths": {
        "3": "Quarter",
        "4": "Third",
        "6": "Half",
        "8": "Two-thirds",
        "9": "Three-quarters",
        "12": "Full width"
      },
      "moveFirst": "Move to Start",
      "moveLast": "Move to End",
      "remove": "Remove from Dashboard",
      "discardTitle": "Discard changes?",
      "discardMessage": "Your unsaved layout changes will be lost.",
      "discard": "Discard",
      "saved": "Dashboard layout saved for {{position}}"
    }
  },
  "adminDashboard": {
    "welcome": "Welcome",
    "systemOverview": "System Overview",
    "roundStatus": "Rounds Status",
    "totalRounds": "Total Rounds",
    "manageRounds": "Manage Rounds",
    "configuration": "Configuration",
    "manageHierarchy": "Manage Hierarchy",
    "manageOperationalPositions": "Manage Operational Positions",
    "manageSchedules": "Manage Schedules",
    "viewReports": "View Reports"
  },
  "operatorHome": {
    "welcome": "Operator Dashboard",
    "myRounds": "My Rounds",
    "myRoundsTitle": "My Rounds",
    "noRounds": "No rounds assigned for this shift.",
    "viewMyRounds": "View My Rounds",
    "openExceptions": "Open Exceptions",
    "exceptionsInfo": "View and manage exceptions raised during your rounds.",
    "viewExceptions": "View Exceptions",
    "quickActions": "Quick Actions",
    "startRound": "Start Round",
    "raiseException": "Raise Exception",
    "viewHandover": "View Handover",
    "workContext": {
      "title": "Select your work context",
      "prompt": "Choose your work location and active shift to see the rounds for your area.",
      "node": "Work location",
      "shift": "Active shift",
      "noShifts": "No active shifts available.",
      "select": "Select work context",
      "change": "Change",
      "confirm": "Confirm"
    }
  },
  "supervisorHome": {
    "welcome": "Supervisor Dashboard",
    "executionOverview": "Shift Execution Overview",
    "actions": "Supervisor Actions",
    "manageSchedule": "Manage Schedule",
    "handovers": "Handovers",
    "pendingApprovals": "Pending Approvals",
    "areaRollup": "Area Roll-Up",
    "reports": "Reports"
  },
  "errors": {
    "serverError": "A server error occurred. Please try again later.",
    "networkError": "Unable to connect to the server. Check your connection.",
    "unexpected": "An unexpected error occurred.",
    "forbidden": "You do not have permission to perform this action.",
    "businessRule": "A business rule was violated.",
    "businessRuleTitle": "Cannot Complete Action",
    "validationTitle": "Check the Entered Values",
    "loadingData": "Failed to load data.",
    "saveFailed": "Failed to save. Please try again.",
    "deleteFailed": "Failed to delete. Please try again.",
    "backToHome": "Go to Home",
    "notFound": {
      "title": "Page Not Found",
      "message": "The page you are looking for does not exist."
    },
    "server": {
      "title": "Server Error",
      "message": "An internal server error occurred. Please try again later."
    },
    "serverUnavailable": {
      "title": "Can't reach the server",
      "message": "OpsHub can't connect to the server, so nothing can be loaded or saved right now.",
      "hint": "The page reloads automatically as soon as the connection is back.",
      "retry": "Try again",
      "checking": "Checking…",
      "reload": "Reload page",
      "game": {
        "title": "Flowline Fitter",
        "intro": "The server's down, but the oil keeps coming. Lay pipe from the wellhead to the tank before the flow starts — every pipe the oil runs through scores.",
        "controls": "Click a square to lay the next piece from the left. Opening the valve early scores a bonus. Keyboard: arrow keys to move, Space to lay, V for the valve.",
        "start": "Start laying pipe",
        "bestSoFar": "Your best: {{score}}",
        "level": "Level",
        "score": "Score",
        "best": "Best",
        "flowIn": "Oil flows in {{seconds}} s",
        "flowing": "Oil is flowing",
        "fastFlow": "Fast flow — double points",
        "openValve": "Open valve",
        "speedUp": "Speed up",
        "tankFilled": "Tank filled!",
        "levelComplete": "Level {{level}} complete: +{{bonus}} points.",
        "nextLevel": "Next level",
        "spill": "Spill!",
        "spillDetail": "The oil hit an open end. Final score: {{score}}.",
        "newBest": "New best score!",
        "playAgain": "Play again",
        "boardLabel": "Flowline Fitter game board. Arrow keys move, Space lays the next pipe, V opens the valve."
      }
    },
    "unauthorized": {
      "title": "Unauthorized",
      "message": "You do not have permission to access this page.",
      "signInAgain": "Sign in again"
    }
  },
  "messages": {
    "created": "Item created successfully.",
    "updated": "Item updated successfully.",
    "deleted": "Item deleted successfully.",
    "saved": "Saved successfully."
  },
  "hierarchy": {
    "title": "Hierarchy Management",
    "level": "Level",
    "inactive": "Inactive",
    "confirmDeactivate": "Are you sure you want to deactivate \"{{name}}\"? This cannot be undone if there are active children.",
    "tabs": {
      "overview": "Overview",
      "positions": "Operational Positions",
      "equipment": "Equipment",
      "users": "Users"
    },
    "counts": {
      "positions": "Operational positions",
      "shifts": "Shifts",
      "equipment": "Equipment",
      "users": "Users",
      "directOf": "{{count}} here",
      "split": "{{below}} in sub-locations · {{total}} total",
      "rollupHint": "The figure is what is attached to this location itself. The line beneath it counts everything in the locations below."
    },
    "search": {
      "placeholder": {
        "overview": "Search locations...",
        "positions": "Search operational positions...",
        "equipment": "Search equipment...",
        "users": "Search users..."
      },
      "path": "Path",
      "locationResults": "{{count}} matching location(s) across all levels. Select one to open it.",
      "positionResults": "{{count}} matching operational position(s) across all locations.",
      "userResults": "{{count}} matching user(s) across all locations.",
      "noLocations": "No locations match your search.",
      "noPositions": "No operational positions match your search.",
      "noUsers": "No users match your search."
    },
    "users": {
      "title": "Users at this location",
      "hint": "Users reach a location through an Operational Position. Edit membership on the Operational Positions tab.",
      "empty": "No users hold an operational position at this location.",
      "addUserBlocked": "Add an operational position first — there is nothing to assign a user to yet.",
      "noPositionsTitle": "Add an operational position first",
      "noPositionsDetail": "People are not attached to a location directly. They hold an operational position, and the position is what places them here.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "positions": "Operational Positions",
        "locations": "Locations"
      }
    },
    "actions": {
      "addChild": "Add child node",
      "deactivate": "Deactivate"
    },
    "fields": {
      "name": "Name",
      "displayName": "Display Name",
      "sortOrder": "Sort Order",
      "status": "Status",
      "isActive": "Active",
      "lastEdited": "Last Edited"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "treePanel": {
      "title": "Hierarchy",
      "empty": "No locations found. Add a root node to get started.",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "expandLevel": "Expand one level",
      "collapseLevel": "Collapse one level",
      "resize": "Resize the hierarchy panel",
      "showInactive": "Show inactive locations",
      "hideInactive": "Hide inactive locations"
    },
    "detailPanel": {
      "selectPrompt": "Select a location from the tree to view its details."
    },
    "nodeForm": {
      "createTitle": "Add Hierarchy Node",
      "createTitleAtLevel": "Add Level {{level}} Hierarchy Node",
      "editTitle": "Edit Hierarchy Node",
      "parentLabel": "Parent",
      "namePlaceholder": "Enter node name",
      "displayNamePlaceholder": "Optional display name",
      "displayNameHint": "Overrides Name in the UI. Leave blank to use Name.",
      "nameRequired": "Name is required.",
      "nameMaxLength": "Name cannot exceed 200 characters."
    },
    "operators": {
      "title": "Assigned Operators",
      "manage": "Manage Operators",
      "assignTitle": "Manage Operator Assignments",
      "searchLabel": "Add Operator",
      "searchPlaceholder": "Search by name or email...",
      "assignedLabel": "Currently Assigned",
      "noResults": "No users found.",
      "empty": "No operators assigned to this node.",
      "columns": {
        "name": "Name",
        "email": "Email"
      }
    },
    "groups": {
      "title": "Operational Positions",
      "empty": "No operational positions assigned directly to this location.",
      "add": "Add Position",
      "inherited": "Inherited from parent locations (applies here and to child locations)",
      "rollupHint": "These are the operational positions assigned at or beneath this location, plus those that cover the whole Business Unit.",
      "rollupEmpty": "No operational positions are assigned at or beneath this location.",
      "wholeBu": "Whole Business Unit",
      "confirmRemove": "Remove operational position \"{{name}}\" from this location?",
      "columns": {
        "name": "Name",
        "role": "System Role",
        "members": "Members",
        "assignedAt": "Assigned At"
      }
    }
  },
  "rounds": {
    "title": "Rounds",
    "empty": "No rounds found.",
    "searchPlaceholder": "Search round titles, tasks, equipment, status, area…",
    "matchedTasks": "Matching tasks:",
    "statusFilter": "Filter by Status",
    "confirmRetire": "Are you sure you want to retire this round?",
    "confirmSuspend": "Are you sure you want to suspend this round?",
    "confirmPublish": "Are you sure you want to publish this round? It will be available for scheduling.",
    "validationReview": {
      "requestButton": "Request Validation",
      "requestConfirm": "Request a field test for this round? It will move to Validation Review until completed.",
      "requestSuccess": "Validation review requested.",
      "requestFailed": "Failed to request the validation review.",
      "completeButton": "Complete Validation Review",
      "completeTitle": "Complete Validation Review",
      "completeHint": "Record who performed the field test. The round stays in Validation Review — you can then revert it to Draft or publish it.",
      "completedByLabel": "Completed by",
      "complete": "Complete",
      "completeSuccess": "Validation review completed.",
      "completeFailed": "Failed to complete the validation review."
    },
    "deleted": {
      "show": "Display deleted only",
      "badge": "Deleted",
      "empty": "No deleted rounds."
    },
    "delete": {
      "title": "Delete Round",
      "message": "Delete the draft round \"{{title}}\"? It moves to deleted rounds and can be restored later.",
      "success": "Round deleted."
    },
    "restore": {
      "title": "Restore Round",
      "message": "Restore \"{{title}}\"? It comes back as a Draft.",
      "success": "Round restored as a draft."
    },
    "revertToDraft": {
      "title": "Move Round Back to Draft",
      "hint": "Only draft rounds can be deleted, and \"{{title}}\" is {{status}}. Confirming returns it to Draft, so it stops being available for scheduling and execution — you can then delete it. Record why, so the change stays traceable.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "e.g., Replaced by the consolidated day-shift round.",
      "confirm": "Move to Draft",
      "success": "Round moved back to Draft. You can delete it now.",
      "notAllowed": "You do not have permission to change this round's status."
    },
    "reject": {
      "title": "Reject Round",
      "hint": "Provide comments explaining why this round is being rejected. The author will see these comments on the draft.",
      "commentsLabel": "Rejection comments",
      "commentsPlaceholder": "e.g., Step 4 is missing the safe pressure range; please add acceptance criteria.",
      "rejectedHeading": "This round was rejected and returned to Draft. Reviewer comments:"
    },
    "publish": {
      "title": "Publish Round",
      "hint": "Choose when this round becomes available for scheduling and execution.",
      "immediate": "Publish immediately",
      "scheduled": "Schedule for a future date",
      "effectiveDate": "Effective date",
      "effectiveTime": "Time"
    },
    "approvers": {
      "heading": "Eligible approvers (contributors to this version are excluded):",
      "youAreExcluded": "You cannot approve this version because you authored or contributed to it (separation of duties).",
      "none": "No eligible approver found. Only Business Unit Admins who did not contribute to this version can approve it."
    },
    "review": {
      "bannerHeading": "Review mode — this round is read-only",
      "bannerBody": "Nothing you do here is saved, so reading the round will not make you a contributor or affect your eligibility to approve it.",
      "switchToEditing": "Switch to Editing"
    },
    "submitReview": {
      "title": "Submit for Review",
      "hint": "This round will move to Under Review. The approvers below will be notified.",
      "approversLabel": "Approvers who will review this",
      "noApprovers": "No eligible approver found. An administrator who did not contribute to this version must be assigned before it can be approved.",
      "commentsLabel": "Note to approvers (optional)",
      "commentsPlaceholder": "e.g., Updated the valve isolation steps for the Q3 shutdown — please review section 2.",
      "authorNoteHeading": "Author's note to approvers:"
    },
    "validation": {
      "passed": "Validation passed",
      "failed": "Validation failed",
      "valid": "All validation checks passed",
      "invalid": "Validation issues found",
      "warningsDoNotBlock": "Warnings are advisory and do not prevent publishing.",
      "issuesFound": "Validation issues detected — please fix before publishing:"
    },
    "actions": {
      "create": "New Round",
      "changeRequests": "Change Requests",
      "revalidation": "Revalidation",
      "schedules": "Schedules",
      "schedule": "Schedule",
      "duplicate": "Duplicate",
      "review": "Review",
      "restore": "Restore",
      "submit": "Submit for Review",
      "markComplete": "Mark Round Complete",
      "approve": "Approve",
      "reject": "Reject",
      "publish": "Publish",
      "retire": "Retire",
      "suspend": "Suspend",
      "newVersion": "New Version",
      "validate": "Validate",
      "preview": "Preview",
      "editMetadata": "Edit Details",
      "rename": "Rename round",
      "exportExcel": "Export Excel",
      "exportPdf": "Export PDF",
      "exportJson": "Export JSON",
      "import": "Import",
      "submitSuccess": "Round submitted for review.",
      "markCompleteSuccess": "Round marked complete.",
      "markCompleteConfirm": "Mark this round complete? Its approval is already carried by the linked change request — you can then request a validation review or publish.",
      "approveSuccess": "Round approved.",
      "rejectSuccess": "Round rejected.",
      "publishSuccess": "Round published successfully.",
      "retireSuccess": "Round retired.",
      "suspendSuccess": "Round suspended."
    },
    "fields": {
      "title": "Title",
      "description": "Description",
      "status": "Status",
      "version": "Version",
      "author": "Authored By",
      "approver": "Approved By",
      "node": "Hierarchy Node",
      "revalidation": "Revalidation",
      "createdOn": "Created",
      "createdBy": "Created By",
      "updatedBy": "Last Updated By",
      "updatedOn": "Last Updated",
      "deletedBy": "Deleted By",
      "deletedOn": "Deleted",
      "taskCount": "Tasks",
      "estimatedDuration": "Estimated Duration (min)"
    },
    "status": {
      "draft": "Draft",
      "underReview": "Under Review",
      "approved": "Approved",
      "published": "Published",
      "retired": "Retired",
      "suspended": "Suspended"
    },
    "sla": {
      "due": "Due",
      "overdue": "Overdue"
    },
    "newVersion": {
      "title": "Create New Version",
      "hint": "Choose the change tier. Minor changes may be self-approved; major changes require a separate approver.",
      "changeTypeLabel": "Change Type",
      "changeTypeLockedHint": "Set by the change request — cannot be changed here.",
      "minor": "Minor (sub-version, e.g. 2.0 → 2.1)",
      "major": "Major (new version, e.g. 2.1 → 3.0)",
      "changeNotesLabel": "Change Notes",
      "changeNotesPlaceholder": "Describe what changed in this version",
      "bannerHeading": "Version {{version}} draft created",
      "bannerBody": "This round is now an editable draft. Make your changes, then submit it for review.",
      "minorTag": "Minor change",
      "majorTag": "Major change"
    },
    "form": {
      "createTitle": "New Round",
      "editTitle": "Edit Round",
      "titlePlaceholder": "Enter round title",
      "descriptionPlaceholder": "Enter round description"
    },
    "wizard": {
      "title": "Create Round",
      "metadataStep": "Round Details",
      "scheduleStep": "Initial Schedule",
      "tasksStep": "Tasks",
      "metadataStepHint": "Describe the round. You can add tasks after it is created.",
      "fromRequestTitle": "Building From Approved Change Request",
      "metaRequest": "Change Request",
      "metaStatus": "Approval Status",
      "metaValidation": "Validation Required",
      "metaFrequency": "Requested Frequency",
      "metaMoc": "MOC / TMOC Number",
      "metaLink": "Details",
      "yes": "Yes",
      "no": "No",
      "fromRequestHint": "Prefilled from the request. Check the Area/Unit and the initial schedule against what was asked for — the requested tasks are added to the round when you finish.",
      "scheduleStepHint": "Set up how often this round runs. Choose \"Dynamic / Ad-hoc\" if it has no fixed schedule.",
      "tasksStepHint": "After the round is created, you'll add its tasks in the round editor.",
      "schedulingFor": "Scheduling for",
      "next": "Next",
      "back": "Back",
      "finish": "Create Round",
      "scheduleFailed": "The round was created, but its schedule could not be saved. You can add a schedule later."
    },
    "metadataPage": {
      "title": "Edit Round Details"
    },
    "editor": {
      "structure": "Structure",
      "versions": "Versions",
      "details": "Details"
    },
    "tabs": {
      "structure": "Tasks",
      "versions": "Version History",
      "schedules": "Schedules",
      "details": "Details & Attachments"
    },
    "schedules": {
      "title": "Schedules",
      "add": "Add Schedule",
      "empty": "No schedules yet. Add one so operators can run this round.",
      "active": "Active",
      "inactive": "Inactive"
    },
    "taskGroups": {
      "title": "Containers",
      "empty": "No containers. Add one to get started.",
      "selectGroup": "Select a container to view its tasks.",
      "addGroup": "Add Container",
      "addSubGroup": "Add Sub-Container",
      "editGroup": "Edit Container",
      "addChild": "Add Child Container",
      "addTask": "Add Task",
      "expand": "Expand",
      "collapse": "Collapse",
      "required": "Required",
      "optional": "Optional",
      "tasks": "tasks",
      "subGroups": "Sub-Containers",
      "whenAnswer": "When answer",
      "conditionalGroup": "Conditional sub-container",
      "name": "Name",
      "description": "Description",
      "allowAnyOrder": "Allow tasks in any order",
      "assetVerification": "Require Asset Verification"
    },
    "authoring": {
      "addGroup": "Add Group",
      "addTask": "Add Task",
      "tasksTitle": "Tasks",
      "next": "Next",
      "selectHint": "Select an element to view or edit its details.",
      "newElement": "New element",
      "newPlaceholder": "New {{type}}…",
      "defaultName": "New {{type}}",
      "untitled": "Untitled {{type}}",
      "titleRequired": "A title is required. Changes aren't saved until you enter one.",
      "saving": "Saving…",
      "saved": "Saved",
      "discard": "Discard",
      "expression": "Expression",
      "addInstructions": "Add Instructions",
      "expressionEditor": {
        "missingTask": "Missing task",
        "number": "123",
        "text": "\"Text\"",
        "unrecognised": "Not a recognised expression — this will be shown as plain text.",
        "unrecognisedBlocks": "{{blocks}} was not recognised as an expression and will be shown as plain text.",
        "dragHint": "Drag a task from the round structure to use its value.",
        "noResponseType": "“{{title}}” has no response type, so it has no value to use. Give it a response type first.",
        "recordsNoValue": "“{{title}}” records no value, so it can't be used in a calculation.",
        "titlePlaceholder": "Type text, or type '{' to insert a task value…",
        "instructionsPlaceholder": "Type instructions, or type '{' to insert a task value…",
        "contentPlaceholder": "Type the message, or type '{' to insert a task value…",
        "responsePlaceholder": "Type '{' or drag tasks in to calculate the response from their values…",
        "visibilityPlaceholder": "Drag a task in or type '{' to search — e.g. Suction Pressure ≥ 250",
        "brokenBadge": "Broken calculation",
        "calculatedBadge": "Uses a calculation",
        "brokenDescendant": "Contains a broken calculation",
        "warningBadge": "Calculation may not produce a value",
        "warningDescendant": "Contains a calculation that may not produce a value",
        "renameMessage": "{{count}} other task(s) display this task's value. Renaming is safe — the calculation follows the task, not its name.",
        "groups": {
          "operators": "Operators",
          "compare": "Compare",
          "logic": "Logic",
          "dateTime": "Date & Time",
          "values": "Values",
          "tasks": "Task",
          "answers": "Answer"
        },
        "examples": {
          "add": "Reading + 5 — adds two values",
          "subtract": "Reading - 5 — subtracts one value from another",
          "multiply": "Reading * 2 — multiplies two values",
          "divide": "Reading / 2 — divides one value by another",
          "openParen": "(Reading + 5) * 2 — brackets decide what is worked out first",
          "closeParen": "(Reading + 5) * 2 — closes a bracket opened earlier",
          "equal": "Reading = 100 — true when both sides match",
          "notEqual": "Reading <> 100 — true when the two sides differ",
          "lessThan": "Reading < 100 — true below 100",
          "lessOrEqual": "Reading <= 100 — true at 100 or below",
          "greaterThan": "Reading > 100 — true above 100",
          "greaterOrEqual": "Reading >= 100 — true at 100 or above",
          "isBetween": "ISBETWEEN(Reading, 80, 120) — true from 80 to 120, both ends included",
          "contains": "CONTAINS(Issues, \"Leak\") — true when Leak is one of the chosen answers, for a question that allows several",
          "and": "Reading > 80 AND Reading < 120 — true only when both sides are true",
          "or": "Reading < 80 OR Reading > 120 — true when either side is true",
          "not": "NOT Reading = 100 — reverses true and false",
          "if": "IF(Reading > 100, \"High\", \"Normal\") — the first result when the test passes, otherwise the second",
          "today": "TODAY() — today's date, without a time",
          "now": "NOW() — the current date and time",
          "day": "DAY(TODAY()) — day of the month, 1 to 31",
          "month": "MONTH(TODAY()) — month of the year, 1 to 12",
          "hour": "HOUR(NOW()) — hour of the day, 0 to 23",
          "dayOfWeek": "DAYOFWEEK(TODAY()) — day of the week, Monday is 1 and Sunday is 7",
          "lastValue": "LASTVALUE(Reading) — the answer recorded on the previous run of this round",
          "abs": "ABS(Reading - 100) — the size of a value, ignoring any minus sign",
          "comma": "ISBETWEEN(Reading, 80, 120) — separates a function's inputs"
        },
        "diagnostics": {
          "unterminatedHole": "Unterminated '${' in template.",
          "invalidExpression": "Invalid expression.",
          "unexpectedToken": "Unexpected '{{token}}'.",
          "malformedReference": "Malformed task reference — expected '[t:'.",
          "unterminatedReference": "Unterminated task reference — missing ']'.",
          "invalidReference": "'{{reference}}' is not a valid task reference.",
          "unterminatedText": "Unterminated text literal — missing closing quote.",
          "invalidNumber": "'{{number}}' is not a valid number.",
          "unexpectedCharacter": "Unexpected character '{{character}}'.",
          "unexpectedEnd": "Unexpected end of expression.",
          "unknownFunction": "Unknown function '{{name}}'.",
          "wrongArgumentCount": "{{name}} expects {{expected}} argument(s) but got {{actual}}.",
          "lastValueNeedsReference": "LASTVALUE expects a single task reference.",
          "expectedSymbol": "Expected '{{symbol}}'.",
          "unknownReference": "This expression references a task that no longer exists in this round.",
          "nonValueReference": "'{{title}}' does not capture a value, so it cannot be used in an expression.",
          "conditionNotBoolean": "A visibility rule must be a yes/no condition, for example 'Suction Pressure >= 250'.",
          "circularReference": "This expression forms a loop — two tasks reference each other's values.",
          "forwardReference": "'{{title}}' runs after this task, so its value shows as a dash until it is answered.",
          "typeMismatch": "'{{title}}' is not a numeric task, so the calculation may not produce a value.",
          "unitMismatch": "This calculation mixes units ({{units}})."
        }
      },
      "messageContent": "Message",
      "alertMessage": "Alert message",
      "designer": "Task Designer",
      "configuration": "Configuration",
      "structureTitle": "Round Tasks",
      "resizeStructure": "Resize the round structure panel",
      "searchTasks": "Search tasks…",
      "expandAll": "Expand a level",
      "collapseAll": "Collapse a level",
      "noSearchResults": "No tasks match your search.",
      "range": "Range",
      "acceptanceCriteria": "Acceptance Criteria",
      "criticalNeedsCriteria": "A critical task needs acceptance criteria. Add a sub-task, message or alert to it from the Round Tasks tree.",
      "logic": {
        "title": "Visibility",
        "show": "Show Task",
        "conditionNotSet": "Condition not set",
        "incomplete": "This rule is missing a condition and will not work as written. Open Visibility to finish it.",
        "none": "Always shown — no conditions"
      },
      "preview": {
        "title": "Mobile Preview",
        "outOfRange": "Out of range"
      },
      "types": {
        "task": "Task",
        "container": "Group",
        "alert": "Alert",
        "message": "Message"
      },
      "tabs": {
        "responseType": "Response Type",
        "critical": "Critical Task",
        "equipment": "Equipment",
        "visibility": "Visibility",
        "evidence": "Evidence",
        "attachments": "Attachments"
      },
      "summary": {
        "itemOne": "1 item",
        "itemMany": "{{count}} items",
        "fileOne": "1 file",
        "fileMany": "{{count}} files"
      },
      "menu": {
        "addSubtask": "Add Sub-task",
        "addMessage": "Add Message",
        "addAlert": "Add Alert",
        "addSubgroup": "Add Sub-group",
        "duplicate": "Duplicate",
        "templates": "Templates",
        "saveAsTemplate": "Save as Template",
        "insertFromTemplate": "Insert from Template"
      },
      "confirmDeleteSubtree": "Delete \"{{title}}\" and the {{count}} tasks beneath it? This cannot be undone.",
      "visibility": {
        "visible": "Visible",
        "hidden": "Hidden",
        "hiddenHint": "Operators never see this element. It stays in the round, and anything inside it is hidden too.",
        "schedule": "Schedule",
        "expression": "Expression",
        "basedOnResponse": "Based on response",
        "basedOnHint": "Shown when the response to \"{{task}}\" meets:",
        "whenResponse": "When the response is",
        "noParentResponse": "This element has no parent task with a response, so it is always shown."
      },
      "taskTypes": {
        "inspection": "Inspection",
        "reading": "Reading",
        "verification": "Verification",
        "dataEntry": "Data Entry",
        "acknowledgement": "Acknowledgement",
        "photoCapture": "Photo Capture",
        "signature": "Signature",
        "expression": "Expression"
      },
      "responseTypes": {
        "none": "None",
        "radioButton": "Radio Button",
        "multipleChoice": "Multiple Choice",
        "dropdown": "Dropdown",
        "numericInput": "Numeric Input",
        "textInput": "Text Input",
        "booleanYesNo": "Yes / No",
        "passFail": "Pass / Fail",
        "dateInput": "Date Input",
        "signature": "Signature",
        "photoCapture": "Photo Capture"
      },
      "evidenceTypes": {
        "none": "None",
        "photo": "Photo",
        "gps": "GPS Location",
        "nfc": "NFC Scan",
        "qr": "QR Code",
        "barcode": "Barcode",
        "signature": "Signature"
      },
      "conditionOperators": {
        "equal": "= (equals)",
        "notEqual": "≠ (not equal)",
        "lessThan": "< (less than)",
        "lessThanOrEqual": "≤ (less or equal)",
        "greaterThan": "> (greater than)",
        "greaterThanOrEqual": "≥ (greater or equal)",
        "between": "↔ (between)"
      }
    },
    "taskGroupForm": {
      "createTitle": "Add Container",
      "editTitle": "Edit Container",
      "fields": {
        "title": "Title",
        "description": "Description",
        "sortOrder": "Sort Order"
      }
    },
    "tasks": {
      "criticalOperatorTask": "Critical Operator Task",
      "criticalShort": "Critical",
      "criticalMissingCriteria": "Critical task with no acceptance criteria — add a sub-task, message or alert to evidence it",
      "criticalMissingCriteriaDescendant": "Contains a critical task with no acceptance criteria",
      "criticalHint": "Mark tasks that support detection, prevention, mitigation or verification of a risk control.",
      "pendingChange": "An approved change request wants this task revised — click to view the proposed change",
      "pendingChangeShort": "Change pending",
      "pendingRemoval": "An approved change request wants this task removed — click to view the request",
      "pendingRemovalShort": "Removal pending",
      "taskBasis": "Task Basis",
      "taskBasisPlaceholder": "Which risk control or safeguard does this task support?",
      "inputOwner": "Input Owner",
      "inputOwnerSearch": "Search positions…",
      "inputOwnerNone": "No owner",
      "inputOwnerNoMatch": "No matching positions.",
      "empty": "No tasks in this group.",
      "addTask": "Add Task",
      "editTask": "Edit Task",
      "title": "Title",
      "instructions": "Instructions",
      "taskType": "Task Type",
      "responseType": "Response Type",
      "response": "Response",
      "defaultValue": "Default Value",
      "defaultValueNone": "No default",
      "defaultValueHint": "Optional. Pre-filled for the operator, who can accept it as the answer or change it.",
      "defaultValueOutOfRange": "Outside the acceptance range ({{range}}). Every operator would start from an out-of-range reading, so the round can't be published with it.",
      "defaultShort": "Default",
      "defaultValueInvalid": "The default can't be the operator's answer — it isn't one of the options, isn't the right kind of value, or is outside the acceptance range. Fix it before publishing.",
      "defaultValueInvalidDescendant": "Contains a task whose default can't be the operator's answer",
      "evidenceType": "Evidence Required",
      "evidenceLockedHint": "Evidence type is automatically set for Photo Capture tasks.",
      "required": "Required",
      "equipment": "Equipment",
      "unit": "Unit",
      "unitSearch": "Search units…",
      "unitNone": "No unit",
      "unitNoMatch": "No matching units.",
      "value": "Value",
      "valueEnd": "Upper bound",
      "numericConfig": "Numeric Input Configuration",
      "minValue": "Min Value",
      "maxValue": "Max Value",
      "unitOfMeasure": "Unit of Measure",
      "answerOptions": "Answer Options",
      "addOption": "Add Option",
      "optionLabel": "Label",
      "optionValue": "Value",
      "defaultOption": "Default",
      "noOptionsHint": "Add at least one answer option for this response type.",
      "conditionalHint": "Optionally link an answer option to a sub-container that will appear when the option is selected.",
      "conditionalGroup": "Show sub-container when selected",
      "noConditionalGroup": "None (no conditional sub-container)",
      "createSubGroup": "Create Sub-Container",
      "unlinkGroup": "Unlink sub-container",
      "optionalCondition": "(optional — shows extra tasks when selected)",
      "conditionalRules": "Conditional Rules",
      "addRule": "Add Rule",
      "ifValue": "If value",
      "andValue": "and",
      "thresholdValue": "Value",
      "ruleName": "Rule label (optional)",
      "noNumericRulesHint": "Add conditional rules to show sub-containers based on the entered numeric value.",
      "alertCondition": "Alert Condition",
      "alertHint": "Configure an alert that warns the operator when the entered value meets a dangerous condition.",
      "alertOperator": "Alert when value",
      "noAlert": "No alert",
      "alertThreshold": "Alert threshold",
      "alertThresholdEnd": "Upper bound",
      "alertValue": "Alert value",
      "alertValuePlaceholder": "e.g., Fail, No, Abnormal",
      "alertMessage": "Warning message",
      "alertMessagePlaceholder": "e.g., Pressure exceeds safe limit — shut down pump immediately",
      "remediationSteps": "Remediation Steps",
      "remediationStepsHint": "Show remediation steps to the operator when the entered value meets a defined condition.",
      "remediationOperator": "Show when value",
      "noRemediation": "No remediation steps",
      "remediationThreshold": "Trigger threshold",
      "remediationValue": "Trigger value",
      "remediationInstructions": "Remediation steps",
      "remediationInstructionsPlaceholder": "Describe the steps to remediate the situation. You can add images and links.",
      "remediationImageTooLarge": "Image is too large. Maximum size is 5 MB.",
      "remediationNotImage": "Only image files can be embedded.",
      "changeBlockedByRemediation": "Clear the remediation steps (via the Remediation Steps button) before changing the response type.",
      "saveFirstHint": "Save the task first to add attachments and dependencies.",
      "advanced": "Advanced",
      "changeBlockedByConditionalSubGroup": "Remove the conditional sub-containers linked to this task's answer options before changing the response type.",
      "changeBlockedByAlert": "Clear the alert condition (via the Alerts button) before changing the response type.",
      "confirmChangeResponseType": "Changing the response type will remove all existing answer options. Do you want to continue?",
      "confirmChangeFromNumeric": "Changing away from Numeric Input will clear the min/max/unit configuration and any conditional rules. Do you want to continue?",
      "visibility": {
        "chip": "Conditional Visibility",
        "title": "Conditional Visibility",
        "hint": "Show this task on a round only when the schedule below is due. When not due, the task stays hidden and is optional.",
        "enable": "Only show this task on a schedule",
        "anchor": "Starting from",
        "startDate": "Start date",
        "repeat": "Repeat",
        "intervalHint": "The task becomes visible again once the interval has elapsed since the last execution, then hides again after it is completed.",
        "calendarHint": "The task is visible on the recurring dates calculated from the starting point.",
        "anchors": {
          "specificDate": "A specific date",
          "lastTaskExecution": "Last time this task was executed",
          "lastRoundExecution": "Last time the round was executed",
          "startOfYear": "Start of the year",
          "startOfMonth": "Start of the month",
          "startOfWeek": "Start of the week"
        }
      },
      "optionNumbered": "Option {{number}}"
    },
    "taskForm": {
      "createTitle": "Add Task",
      "editTitle": "Edit Task",
      "fields": {
        "title": "Title",
        "instructions": "Instructions",
        "type": "Task Type",
        "evidenceType": "Evidence Required",
        "minValue": "Min Value",
        "maxValue": "Max Value",
        "unit": "Unit",
        "isRequired": "Required",
        "isCritical": "Critical"
      }
    },
    "versions": {
      "title": "Version History",
      "number": "Version",
      "version": "Version",
      "empty": "No version history yet.",
      "changeDescription": "Change Description",
      "duration": "Est. Duration",
      "publishedAt": "Published",
      "publishedBy": "Published By",
      "active": "Active",
      "compare": {
        "heading": "Compare Versions",
        "from": "From",
        "to": "To",
        "swap": "Swap the two versions",
        "needTwo": "Comparison needs at least two versions.",
        "pickTwo": "Pick two different versions to compare.",
        "identical": "No task differences between these versions.",
        "task": "Task",
        "change": "Change",
        "details": "What changed",
        "added": "Added",
        "removed": "Removed",
        "changed": "Changed",
        "fields": {
          "title": "Title",
          "instructions": "Instructions",
          "content": "Body",
          "taskType": "Type",
          "responseType": "Response",
          "evidence": "Evidence",
          "required": "Required",
          "critical": "Critical",
          "visibility": "Visibility",
          "visibilityRule": "Visibility rule",
          "min": "Minimum",
          "max": "Maximum"
        }
      }
    },
    "attachments": {
      "title": "Attachments",
      "upload": "Upload",
      "none": "No attachments",
      "empty": "No files attached yet.",
      "uploaded": "Attachment uploaded.",
      "uploadFailed": "Failed to upload attachment.",
      "confirmDelete": "Are you sure you want to delete this attachment?",
      "deleted": "Attachment deleted.",
      "deleteFailed": "Failed to delete attachment."
    },
    "equipment": {
      "title": "Equipment Association",
      "search": "Search Equipment",
      "searchPlaceholder": "Type equipment tag or name...",
      "none": "No equipment associated.",
      "selectedHeading": "Selected equipment ({{count}})"
    },
    "dependencies": {
      "title": "Task Dependencies",
      "none": "No dependencies defined.",
      "empty": "No prerequisite task set.",
      "hint": "This task becomes available only after its prerequisite task is completed.",
      "addPredecessor": "Add prerequisite task",
      "confirmDelete": "Are you sure you want to remove this dependency?",
      "deleted": "Dependency removed.",
      "types": {
        "mustComplete": "Must Complete",
        "mustStart": "Must Start"
      }
    },
    "statusDashboard": {
      "title": "Rounds Status Dashboard",
      "totalRounds": "total rounds",
      "all": "All",
      "draft": "Draft",
      "review": "In Review",
      "approved": "Approved",
      "published": "Published",
      "retired": "Retired",
      "suspended": "Suspended",
      "deleted": "Deleted"
    },
    "templates": {
      "saveTitle": "Save as Template",
      "pickerTitle": "Insert from Template",
      "name": "Template name",
      "category": "Category",
      "allCategories": "All categories",
      "description": "Description",
      "descriptionPlaceholder": "What is this template for?",
      "itemCount": "Elements",
      "apply": "Insert",
      "saveHint": "\"{{title}}\" and everything beneath it will be saved.",
      "applyUnder": "The template will be inserted under \"{{title}}\".",
      "applyAtRoot": "The template will be inserted at the end of the round.",
      "searchPlaceholder": "Search templates...",
      "noTemplates": "No templates match your filters.",
      "noCategories": "No template categories have been set up yet. An administrator can add them under Admin → Template Categories.",
      "saved": "Template \"{{name}}\" saved.",
      "replaced": "Template \"{{name}}\" replaced.",
      "modeNew": "Save as a new template",
      "modeOverwrite": "Replace an existing template",
      "templateToReplace": "Template to replace",
      "noTemplatesInCategory": "This category has no saved templates yet. Choose another category.",
      "replace": "Replace",
      "overwriteWarning": "This replaces all {{count}} saved elements of \"{{name}}\". Rounds already built from it are not changed.",
      "deleteTitle": "Delete template",
      "confirmDelete": "Delete \"{{name}}\" permanently? Rounds already built from it are not affected, but the template cannot be recovered.",
      "deleteFailed": "The template could not be deleted.",
      "saveFailed": "The template could not be saved.",
      "applyFailed": "The template could not be inserted."
    },
    "revalidation": {
      "title": "Revalidation Schedule",
      "noScheduled": "No rounds scheduled for revalidation.",
      "overdue": "overdue revalidations",
      "round": "Round",
      "dueDate": "Due Date",
      "nextDue": "Next Due",
      "lastRevalidated": "Last Revalidated",
      "days": "days",
      "assignedTo": "Assigned To",
      "interval": "Interval",
      "status": "Status",
      "statuses": {
        "current": "Current",
        "dueSoon": "Due Soon",
        "overdue": "Overdue"
      }
    },
    "importSuccess": "Round imported successfully.",
    "importFailed": "Failed to import round.",
    "newVersionCreated": "New version created successfully.",
    "newRoundSource": {
      "title": "Start a new round",
      "hint": "These approved change requests are waiting for a round to be built. Pick one to start from it, or start from scratch.",
      "none": "No approved requests are waiting to be built.",
      "taskCount": "{{count}} requested task(s)",
      "requestValidation": "Require a validation review (in-field test) before this round can be published",
      "startBlank": "Start from scratch",
      "build": "Build from request"
    },
    "requestedTasks": {
      "heading": "Requested in the change request",
      "hint": "What the requestor asked for. Add or adjust tasks in the round to cover these.",
      "proposedChange": "Proposed change",
      "actionAndMethod": "Action & method",
      "operatorResponse": "Operator response",
      "acceptanceCriteria": "Acceptance criteria",
      "justification": "Justification",
      "inputOwner": "Proposed Input Owner"
    },
    "duplicated": "Round copied. You are now editing the copy.",
    "duplicateFailed": "The round could not be copied.",
    "preview": {
      "title": "Round Preview",
      "simulationMode": "Simulation Mode",
      "mobileView": "Mobile View",
      "desktopView": "Desktop View",
      "noTaskGroups": "No containers to preview.",
      "enterValue": "Enter value…",
      "enterNumber": "Enter number…",
      "range": "Value must be between {{min}} and {{max}}",
      "progress": "{{done}} of {{total}} tasks completed",
      "searchPlaceholder": "Search tasks, description, equipment...",
      "collapseAll": "Collapse",
      "expandAll": "Expand",
      "critical": "CRITICAL",
      "acknowledge": "Acknowledge",
      "acknowledged": "Acknowledged",
      "complete": "Complete Round",
      "photoPlaceholder": "Photo captured on the device",
      "calculated": "Calculated",
      "calculatedPending": "Waiting for the values it uses",
      "defaultHint": "Pre-filled default — change it if it does not match.",
      "cannotComplete": "{{count}} required task(s) still need an answer.",
      "lockedNotice": "Round completed. Answers are locked.",
      "reopen": "Reopen Round",
      "saveAndClose": "Continue Later",
      "noTasks": "No tasks found. Sync to refresh.",
      "noResults": "No tasks match your search.",
      "filters": {
        "completed": "Completed",
        "alerts": "Alerts",
        "skipped": "Skipped",
        "notCompleted": "Not Completed"
      },
      "hideTools": "Hide filters and search"
    }
  },
  "approvalWorkflows": {
    "title": "Approval Workflows",
    "empty": "No approval workflows are available.",
    "notConfigured": "Not configured",
    "noStages": "No stages — requests of this type are approved automatically.",
    "readOnlyBypass": "MOC/TMOC-sourced changes arrive already approved externally, so this workflow has no stages and cannot be configured. The Builder must still verify the approved source before publishing.",
    "parallelHint": "Stages sharing an order run in parallel; the next order waits for all of them.",
    "saved": "Approval workflow saved.",
    "columns": {
      "requestType": "Request Type",
      "classification": "Classification",
      "stages": "Stages"
    },
    "kinds": {
      "advisory": "Advisory",
      "finalAuthority": "Final Authority"
    },
    "fields": {
      "name": "Stage Name",
      "kind": "Kind",
      "sortOrder": "Order",
      "requiredApprovals": "Required Approvals",
      "durationHours": "SLA (hours)",
      "durationHint": "Captured now; overdue notifications arrive in a later release.",
      "permission": "Approver Permission",
      "permissionHint": "Anyone holding this permission may act. Leave blank to restrict the stage to the named approvers below.",
      "assignees": "Named Approvers"
    },
    "assignees": {
      "type": "Type",
      "user": "User",
      "position": "Operational Position",
      "directoryUser": "Chevron Directory (no Ops Hub account)",
      "search": "Search",
      "searchHint": "Type at least 2 characters",
      "remove": "Remove approver",
      "title": "Approvers",
      "choose": "Choose approvers",
      "done": "Done",
      "noResults": "Nothing matches that search.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "title": "Title / Role",
        "location": "Location"
      },
      "none": "No named approvers — the stage relies on its approver permission."
    },
    "actions": {
      "addStage": "Add Stage",
      "removeStage": "Remove"
    },
    "errors": {
      "multipleFinalAuthority": "A workflow can have only one final authority stage.",
      "majorNeedsFinalAuthority": "A Major workflow must keep exactly one final authority stage.",
      "stageNeedsApprover": "Every stage needs an approver permission or at least one named approver.",
      "finalAuthorityNotLast": "The final authority stage must be last — no stage may share or follow its order."
    }
  },
  "changeRequests": {
    "title": "Change Requests",
    "empty": "No change requests found.",
    "confirmWithdraw": "Are you sure you want to withdraw this change request? The round stays on its current version.",
    "withdrawn": "Change request withdrawn.",
    "submitted": "Change request submitted for review.",
    "implemented": "Change request marked as implemented.",
    "reviewSaved": "Review recorded.",
    "newRoundBadge": "NEW",
    "actions": {
      "create": "New Request",
      "open": "Open Workflow",
      "requestChange": "request change",
      "submit": "Submit Request",
      "approve": "Approve",
      "reject": "Reject",
      "implement": "implement",
      "apply": "Apply Change",
      "viewDiff": "View Request",
      "withdraw": "Withdraw Request"
    },
    "editor": {
      "bannerHeading": "{{count}} change request(s) on this round",
      "keepAlongside": "Keep alongside",
      "hideAlongside": "Hide panel",
      "archivePending": "{{count}} task(s) approved for archive — remove them and publish a new version",
      "archiveTasks": "{{count}} task(s)",
      "archivePendingBadge": "Archive pending",
      "archivePendingHint": "An approved archive request names tasks on this round. Open the round to remove them and publish a new version.",
      "openRequest": "Open Change Request",
      "applyHelperHeading": "Implementing approved change",
      "changeApplied": "Proposed change applied to the task. Review and publish when ready.",
      "applyFailed": "Could not apply the change automatically. Please edit the task manually.",
      "couldNotAutoApply": "Could not identify the target task. Please apply the change manually using the helper panel."
    },
    "fields": {
      "round": "Round",
      "roundId": "Round",
      "requestType": "Request Type",
      "currentStage": "Current Stage",
      "node": "Area / Unit",
      "nodeHint": "Determines the Business Unit the request is routed to.",
      "frequency": "Frequency",
      "frequencyPlaceholder": "e.g. Every shift, Weekly",
      "proposedInputOwner": "Proposed Task Input Owner",
      "proposedInputOwnerNone": "— Not specified —",
      "taskInputOwner": "Input Owner (optional)",
      "mocNumber": "MOC / TMOC Number",
      "mocNumberHint": "Optional. Informational only — the Builder verifies the approved source.",
      "actionAndMethod": "Action and Method",
      "operatorResponse": "Operator Response",
      "acceptanceCriteria": "Acceptance Criteria",
      "title": "Title",
      "type": "Type",
      "status": "Status",
      "justification": "Justification",
      "riskAssessment": "Risk Assessment",
      "submittedAt": "Submitted",
      "affectedTask": "Affected Step / Task",
      "affectedTaskNone": "— None / general change —",
      "affectedTaskLockedHint": "This change request targets the task you opened it from.",
      "affectedTaskSelectRoundFirst": "Please select a Round first — the affected step cannot be chosen until then.",
      "stepReference": "Affected Step (optional)",
      "stepReferencePlaceholder": "e.g. Group 2 / Step 4",
      "stepReferenceHint": "Which task or step does this change affect?",
      "stepReferenceNoTasksHint": "This round has no defined tasks yet — describe the affected step.",
      "currentState": "Current State (optional)",
      "currentStatePlaceholder": "Describe or paste the current wording / value",
      "proposedChange": "Proposed Change",
      "proposedChangePlaceholder": "Describe the change you are requesting",
      "designatedApprover": "Designated Approver (optional)",
      "designatedApproverNone": "Any eligible approver",
      "designatedApproverHint": "For major (MOC) changes, optionally require a specific approver."
    },
    "form": {
      "title": "New Change Request"
    },
    "kinds": {
      "1": "Add",
      "2": "Change Round",
      "3": "Archive Rounds/Tasks",
      "4": "Suspend",
      "5": "New Round"
    },
    "roundReview": {
      "start": "Request a Change",
      "pickHint": "You can still open a step to read its details.",
      "selected": "{{count}} step(s) selected",
      "continue": "Continue",
      "title": "Request a Change",
      "hint": "You are requesting changes to {{round}}. A Builder will review this before anything is altered.",
      "summary": "Summary",
      "summaryPlaceholder": "Briefly, what needs to change?",
      "justification": "Why does this need to change?",
      "justificationPlaceholder": "Explain what you observed",
      "justificationHint": "Applies to every step below.",
      "tasksHeading": "Steps to change ({{count}})",
      "whatToDo": "What should happen to this step",
      "action": {
        "change": "Change",
        "remove": "Remove"
      },
      "proposedChange": "What should it say instead?",
      "proposedChangePlaceholder": "Describe the change you are suggesting",
      "removalNote": "This step will be proposed for removal. No description needed.",
      "dropTask": "Remove this step from the request",
      "incomplete": "{{count}} step(s) still need a description.",
      "submit": "Submit Request",
      "submitted": "Change request submitted for review.",
      "submittedHeading": "Your change request has been submitted",
      "submittedSummary": "{{count}} step(s) · {{status}}",
      "submittedNext": "A Builder will classify it and route it for approval. Nothing on this round changes until then.",
      "submitFailed": "Could not submit the change request."
    },
    "statuses": {
      "1": "Draft",
      "2": "Submitted",
      "3": "Under Review",
      "4": "Approved",
      "5": "Rejected",
      "6": "Implemented",
      "7": "Cancelled",
      "8": "Classified",
      "9": "Returned"
    },
    "classifications": {
      "1": "Minor",
      "2": "Major",
      "3": "MOC/TMOC-Sourced"
    },
    "workbench": {
      "title": "Change Workbench",
      "hint": "Every change request in this Business Unit, filterable for reporting and audit. Read-only — open a request to act on it.",
      "ownHint": "Raise a change request and follow the ones you raised. Reviewers see every request in the Business Unit here.",
      "empty": "No change requests match these filters.",
      "matchCount": "{{count}} matching request(s)",
      "ageDays": "{{count}}d",
      "columns": {
        "classification": "Classification",
        "submittedBy": "Requestor",
        "age": "Age"
      },
      "filters": {
        "all": "All",
        "anyone": "Anyone",
        "person": "Requestor",
        "capacity": "Acting as",
        "openOnly": "Open requests only",
        "mineOnly": "My requests only",
        "apply": "Apply",
        "clear": "Clear"
      },
      "capacities": {
        "SubmittedBy": "Requestor",
        "ClassifiedBy": "Builder (classified)",
        "OperationsAuthorityUserId": "Operations Authority",
        "ReviewerUserId": "Reviewer",
        "InputOwnerUserId": "Task Input Owner"
      },
      "actions": {
        "evidence": "View workflow evidence"
      },
      "evidence": {
        "title": "Workflow Evidence",
        "generated": "Generated by {{user}}",
        "failed": "Could not load the workflow evidence.",
        "request": "Request",
        "pipeline": "Approval Pipeline",
        "auditTrail": "Audit Trail",
        "noStages": "No approval stages were recorded for this request.",
        "noDecisions": "No decisions recorded on this stage.",
        "noTrail": "No audit entries recorded for this workflow yet.",
        "when": "When",
        "action": "Action",
        "who": "Who",
        "role": "Role",
        "comments": "Comments"
      }
    },
    "intake": {
      "title": "Request a Change",
      "resubmitTitle": "Edit and Resubmit Change Request",
      "hint": "Anyone can raise a change request. Choose the Area/Unit affected, describe what should change, and a Builder will review it.",
      "newRequest": "New Request",
      "submit": "Submit Request",
      "resubmit": "Resubmit Request",
      "submitted": "Change request submitted.",
      "resubmitted": "Change request resubmitted for review.",
      "notReturned": "This change request is no longer waiting on you, so it cannot be resubmitted.",
      "requestTypeFixed": "The request type cannot be changed. To ask for something different, withdraw this request and raise a new one.",
      "submitFailed": "Could not submit the change request.",
      "selectNodeFirst": "Select an Area/Unit first.",
      "noRoundsAtNode": "No published rounds at this Area/Unit.",
      "roundHasNoTasks": "This round has no tasks yet.",
      "selectTasksHint": "Select the tasks you need revised or removed.",
      "archiveWholeRound": "No tasks selected — the entire round will be archived and removed from circulation. Select tasks below to archive only those.",
      "archiveSelectedTasks": "Only the selected tasks will be archived. Clear the selection to archive the entire round instead.",
      "perTaskDetail": "Detail per selected task",
      "detailWithheld": "Task detail is limited to titles because you do not have round-viewing permission.",
      "addTask": "Add Task",
      "mustBeNumeric": "This field must be a number.",
      "proposedTasksHint": "Describe each task the new round should contain.",
      "newRoundOnlyHint": "Required to define a new round.",
      "requestTypeHint": "Choose what you are asking for — the rest of the form follows from this.",
      "requestTypePlaceholder": "Select a request type",
      "noTasksYet": "No tasks added yet.",
      "pickTasksHeading": "Which tasks are affected?",
      "pickTasksChangeBody": "Choose the tasks you want modified or removed. You can describe the change for each one after selecting.",
      "pickTasksArchiveBody": "Choose the tasks to archive. Leave this empty to archive the entire round.",
      "taskPlaceholders": {
        "actionAndMethod": "What should the operator do, and how?",
        "operatorResponse": "e.g. Record reading",
        "acceptanceCriteria": "e.g. 40-60%"
      },
      "selectRoundFirst": "Choose a round above to pick its tasks.",
      "noTasksPicked": "No tasks selected yet. Use Select Tasks to choose the ones you need changed.",
      "addNewTask": "Add a new task",
      "newTasksHint": "Optional. Describe any task that should be added to this round.",
      "grid": {
        "task": "Task",
        "action": "Action",
        "proposedChange": "Proposed change",
        "justification": "Justification"
      },
      "picker": {
        "open": "Select Tasks",
        "change": "Change selection",
        "title": "Select tasks",
        "search": "Search tasks",
        "selected": "{{count}} of {{total}} selected",
        "selectAll": "Select all",
        "clear": "Clear",
        "confirm": "Use selected tasks",
        "noMatches": "No tasks match that search."
      },
      "errors": {
        "titleTooLong": "Keep the title to 500 characters or fewer."
      },
      "blocked": {
        "heading": "Before you can submit:",
        "requestType": "Choose what kind of request this is.",
        "node": "Choose the affected Area/Unit.",
        "round": "Choose the round this request affects.",
        "taskDetail": "Describe the change for every selected task.",
        "newTasks": "Complete every task you are adding — each needs an action and method, an operator response, and acceptance criteria.",
        "unsavedTask": "Save or discard the task you are still writing.",
        "title": "Give the request a title.",
        "proposedChange": "Describe the change you are proposing.",
        "justification": "Explain why the change is needed.",
        "frequency": "State how often the new round should run.",
        "inputOwner": "Name a proposed Task Input Owner.",
        "proposedTasks": "Complete every proposed task — each needs an action and method, an operator response, and acceptance criteria.",
        "customFields": "Complete the required fields under Additional Information."
      },
      "sections": {
        "request": "Request Information",
        "change": "Proposed Change",
        "roundInfo": "Round Information",
        "tasksToChange": "Tasks to Change",
        "tasksToArchive": "Tasks to Archive",
        "newTasks": "Tasks to Add",
        "additional": "Additional Information",
        "proposedTasks": "Proposed Tasks",
        "affectedTasks": "Affected Tasks"
      }
    },
    "my": {
      "title": "My Change Requests",
      "empty": "You have not raised any change requests yet.",
      "returnedFor": "Returned for",
      "viewProgress": "Progress",
      "editAndResubmit": "Edit and Resubmit",
      "withdraw": "Withdraw",
      "withdrawTitle": "Withdraw Change Request",
      "withdrawReason": "Reason (optional)",
      "withdrawReasonPlaceholder": "Why is this request no longer needed? The request will be cancelled and the round stays as it is.",
      "withdrawn": "Change request withdrawn.",
      "withdrawFailed": "Could not withdraw the change request. It may already have been decided.",
      "backToList": "My Change Requests",
      "notFound": "This change request could not be found.",
      "progressFailed": "Could not load the approval progress.",
      "progressTitle": "Approval Progress",
      "notYetClassified": "This request has not been classified yet, so approval has not started.",
      "responded": "{{done}} of {{total}} responded",
      "respondedBy": "Responded"
    },
    "stage": {
      "waitingOnBuilder": "Waiting on Builder",
      "noActiveStage": "No active stage"
    },
    "detail": {
      "title": "Change Request",
      "subtitle": "Change Management Workflow — Request Detail View",
      "notFound": "This change request could not be found.",
      "requestHeaderTitle": "Request Header",
      "requestId": "Request ID",
      "workflowProgressTitle": "Workflow Progress",
      "proposedChangesTitle": "Proposed Changes",
      "rowCount": "{{count}} item(s)",
      "changeTypeHeader": "Change Type",
      "actionHeader": "Action",
      "genericTaskChange": "Task Change",
      "wholeRoundChange": "Round Change",
      "businessJustificationTitle": "Business Justification",
      "commentsAuditTrailTitle": "Comments & Audit Trail",
      "workflowTitle": "Approval Workflow",
      "progress": {
        "submitted": "Submitted",
        "underReview": "Under Review",
        "builderImplementation": "Builder Implementation",
        "validationReview": "Validation Review",
        "publish": "Publish",
        "notRequested": "not requested"
      },
      "timeline": {
        "unknownUser": "the requestor",
        "submitted": "Request submitted by {{name}}.",
        "classified": "Classified as {{classification}}.",
        "returned": "Returned to requestor: {{reason}}",
        "reviewed": "Reviewed.",
        "reviewedWithComments": "Reviewed: {{comments}}",
        "stageDecision": "{{stage}} — {{decision}} by {{name}}.",
        "stageReturned": "{{stage}} sent back by {{name}}: {{reason}}"
      },
      "submittedBy": "Submitted By",
      "builderDecision": "Builder Decision",
      "actionRequired": "Action Required",
      "recorded": "Recorded",
      "classification": "Classification",
      "classifiedAt": "Decided",
      "recordClassification": "Record Classification",
      "classified": "Classification recorded.",
      "classifyFailed": "Could not record the classification.",
      "minorAllowed": "No Major-only factors changed — Minor may be recorded.",
      "minorBlocked": "Minor cannot be recorded — the following changed:",
      "minorBlockedByType": "Minor cannot be recorded — this request type is always classified Major, regardless of what changed.",
      "returnHeading": "Return for more information",
      "returnReason": "Reason",
      "returnReasonPlaceholder": "Explain what the requestor needs to add or correct",
      "returnToRequestor": "Return to Requestor",
      "returned": "Change request returned to the requestor.",
      "returnFailed": "Could not return the change request.",
      "returnedReason": "Returned"
    },
    "approval": {
      "noStagesYet": "This request's workflow currently has no approval stages. As Builder, you may add one below.",
      "parallel": "{{count}} stages run in parallel — the next stage waits for all of them",
      "finalAuthority": "Final Authority",
      "screeningStage": "Risk Assessment Screening",
      "adHoc": "Added to this request",
      "progress": "Progress",
      "assignees": "Approvers",
      "due": "Due",
      "waivedReason": "Waived",
      "waivedBy": "Waived by {{name}}",
      "implementationStage": "Implementation",
      "implementationHint": "Approved and waiting to be built. Open the round to apply this change, then publish a new version to close it.",
      "validationReviewStage": "Validation Review",
      "validationReviewHint": "Awaiting the field test. Record it from the Operations Authority Review section to unblock publication.",
      "createRound": "Create the round",
      "openRound": "Open the round",
      "createRoundTitle": "Create the round for this request?",
      "createRoundMessage": "A draft round will be created at this request's Area/Unit, seeded with a task for each proposed item. You can edit it before publishing.",
      "createRoundConfirm": "Create round",
      "roundCreated": "Round created from this request.",
      "createRoundFailed": "Could not create the round.",
      "unknownApprover": "Unknown approver",
      "override": "Override",
      "eligibleVia": "You may act on this stage via",
      "notYoursToDecide": "This stage is waiting on someone else — you are not named on it and hold no permission that covers it.",
      "submitterCannotDecide": "You raised this change request, so you cannot decide on its stages yourself (separation of duties). It is waiting on another approver.",
      "comments": "Comments",
      "overrideJustification": "Override Justification",
      "overrideHint": "Required — a reviewer recommended against this change.",
      "overrideTitle": "Approve Over a Negative Recommendation",
      "routeToMocCheckbox": "This belongs in the MOC/TMOC process instead — close this request and refer the requestor there",
      "overrideApprove": "Approve",
      "overrideApproveTitle": "Approve This Stage",
      "overrideApproveComments": "Comments",
      "overrideApproved": "Stage approved.",
      "overrideApproveFailed": "Could not approve the stage.",
      "reassign": "Reassign",
      "reassignTitle": "Reassign Final Decision",
      "reassignHint": "Hands this stage's decision to a different user or position. The original assignee(s) no longer see it.",
      "reassignReason": "Why is this being reassigned?",
      "reassigned": "Stage reassigned.",
      "reassignFailed": "Could not reassign the stage.",
      "waive": "Waive Stage",
      "waiveTitle": "Waive This Stage",
      "waiveReason": "Why is this stage being waived?",
      "concludeHint": "Every advisory stage has reported. This pipeline has no final authority stage, so you conclude it.",
      "addStage": "Add Reviewer Stage",
      "addReviewers": "Add additional reviewers",
      "addReviewersHint": "Reviewers added here run in parallel with each other, immediately before the Operations Authority Decision.",
      "locksPipelineTitle": "This locks the approval pipeline",
      "locksPipelineMessage": "Recording this decision starts the Operations Authority Decision. Once it starts, the remaining approval stages are locked and no further reviewers can be added. Continue?",
      "locksPipelineConfirm": "Record and lock",
      "builderClassification": "Builder Classification",
      "sendBack": "Send back to {{stage}}",
      "sendBackTitle": "Send back to {{stage}}?",
      "sendBackMessage": "This reopens {{stage}} for a fresh round. Decisions already recorded there are kept as history. Continue?",
      "sendBackConfirm": "Send back",
      "sendBackNeedsReason": "Add a comment explaining why before sending this stage back.",
      "sentBack": "Stage sent back.",
      "sendBackFailed": "Could not send this stage back.",
      "wasSentBack": "Sent back by {{name}}",
      "stageName": "Stage Name",
      "sortOrder": "Order",
      "sortOrderHint": "Stages sharing an order run at the same time; the next order waits for all of them.",
      "requiredApprovals": "Required Decisions",
      "notEnoughApprovers": "This stage needs {{required}} decision(s) but the approvers you chose cover only {{available}} person(s). Add more approvers or lower the number.",
      "stageReason": "Why is this stage being added?",
      "stageReasonHint": "Recorded on the audit trail.",
      "stageAdded": "Reviewer stage added.",
      "notInvited": "Could not email {{names}} — they have not been notified and may not know a review is waiting.",
      "stageAddFailed": "Could not add the reviewer stage.",
      "decisionRecorded": "Decision recorded.",
      "decisionFailed": "Could not record the decision.",
      "waived": "Stage waived.",
      "waiveFailed": "Could not waive the stage.",
      "concluded": "Approval concluded.",
      "concludeFailed": "Could not conclude the approval.",
      "verbs": {
        "1": "Approve",
        "2": "Reject",
        "3": "Return",
        "4": "Recommend",
        "5": "Recommend Against",
        "6": "Abstain"
      }
    },
    "unclassified": "Unclassified",
    "diff": {
      "title": "Change Request — Proposed Diff",
      "titleNewRound": "Change Request — New Round",
      "titleArchive": "Change Request — Archive",
      "newRoundNotice": "This request proposes creating a new round with the tasks below.",
      "archiveWholeRound": "This request archives the entire round.",
      "archiveTasks": "This request archives {{count}} task(s):",
      "current": "Current State",
      "proposed": "Proposed Change",
      "taskLines": "Requested task changes ({{count}})",
      "untitledTask": "Untitled task",
      "newTask": "New task",
      "addAction": "Add",
      "changeTag": "Change",
      "removeTag": "Remove",
      "removalNote": "Requested for removal from the round.",
      "noContent": "This request did not include a current-state / proposed-change comparison."
    },
    "review": {
      "commentsLabel": "Comments",
      "commentsPlaceholder": "Add review comments (optional)",
      "approveTitle": "Approve Change Request",
      "rejectTitle": "Reject Change Request",
      "inputOwnerTitle": "Input Owner Review",
      "workspaceTitle": "Operations Authority Review",
      "operationsAuthority": "Operations Authority",
      "noMembers": "No members",
      "noAuthority": "None configured",
      "taskBasis": "Task Basis / Risk Linkage",
      "history": "Earlier Requests for This Round",
      "riskScreening": "Risk Assessment Screening",
      "screeningRequired": "Screening must be recorded before this change can be approved.",
      "outcome": "Outcome",
      "screeningComments": "Screening Comments",
      "commentsRequired": "Required when the screening identifies risk.",
      "recordScreening": "Record Screening",
      "screeningRecorded": "Risk screening recorded.",
      "screeningFailed": "Could not record the risk screening.",
      "routedToMoc": "Change request routed to MOC/TMOC.",
      "routeToMocFailed": "Could not route the change request to MOC/TMOC.",
      "proposedInputOwners": "Proposed Input Owners",
      "proposedInputOwnersHint": "Suggested by the requestor per task. Add a reviewer stage above and name the position (A-69).",
      "scopeToTask": "Applies To",
      "wholeRequest": "The whole request",
      "yourReview": "Your Review",
      "advisoryHint": "Advisory only — this never blocks the Operations Authority.",
      "recordInputOwner": "Record Review",
      "inputOwnerRecorded": "Input Owner review recorded.",
      "inputOwnerFailed": "Could not record the Input Owner review.",
      "validationReview": "Validation Review",
      "validationHint": "Recorded here for convenience — this gates publishing the round from the round editor, after the pipeline above has already concluded.",
      "validationOptional": "No validation review has been requested. Publication is not blocked.",
      "requestValidation": "Request Validation Review",
      "validationRequested": "Validation review requested.",
      "validationRequestFailed": "Could not request a validation review.",
      "validationOutstanding": "A validation review was requested and is still outstanding. The round cannot be published until it is recorded.",
      "validationComments": "Validation Findings",
      "recordValidation": "Record Validation Review",
      "validationRecorded": "Validation review recorded.",
      "validationRecordFailed": "Could not record the validation review.",
      "validationRecordedBy": "Validated by",
      "mocSource": "MOC / TMOC Source",
      "mocUnverified": "This change is MOC/TMOC-sourced and bypassed approval. The approved source must be verified before the round can be published.",
      "mocReference": "Approved MOC / TMOC Reference",
      "mocReferenceHint": "The approved source you checked — recorded on the audit trail.",
      "verifyMocSource": "Verify Source",
      "mocVerifiedAs": "Source verified as",
      "mocVerified": "MOC/TMOC source verified.",
      "mocVerifyFailed": "Could not verify the MOC/TMOC source.",
      "outcomes": {
        "1": "No additional risk",
        "2": "Risk mitigated",
        "3": "Requires MOC/TMOC review"
      }
    }
  },
  "scheduling": {
    "title": "Scheduling",
    "listTitle": "Schedule List",
    "viewsNav": "Scheduling views",
    "empty": "No schedules found.",
    "confirmDeactivate": "Are you sure you want to deactivate this schedule?",
    "actions": {
      "create": "New Schedule",
      "deactivate": "Deactivate",
      "scheduleView": "Schedule View",
      "list": "Schedule List",
      "rounds": "Round Status",
      "assignments": "Assignments",
      "calendar": "Calendar",
      "workload": "Workload",
      "scheduleCreated": "Schedule created for {{title}}"
    },
    "filterBanner": "Showing schedules for",
    "publishBanner": {
      "noScheduleTitle": "\"{{title}}\" has been published",
      "noScheduleHint": "No schedule exists yet. Please create a schedule so operators can run this round.",
      "hasScheduleTitle": "\"{{title}}\" has been published",
      "hasScheduleHint": "An existing schedule is shown below. Review it and update if needed for the new version.",
      "roundsMigrated": "{{count}} pending round(s) have been updated to the new version."
    },
    "fields": {
      "round": "Round",
      "type": "Schedule Type",
      "node": "Hierarchy Node",
      "group": "Assigned Operational Position",
      "noGroupsForNode": "No Field Operator or Console Operator operational positions assigned to this node",
      "shifts": "Shifts",
      "shiftsHint": "The shift's start/end time dictates each round's execution window.",
      "noShifts": "No active shifts. Create one under Shift Definitions first.",
      "position": "Operational Position",
      "positions": "Operational Positions",
      "positionsHint": "Each position's shifts dictate the generated rounds' execution windows.",
      "noPositions": "No operational positions at this node work an active shift.",
      "positionShift": "Shift for {{name}}",
      "allShifts": "All shifts",
      "positionShiftHint": "This position works several shifts. Pick one, or keep all shifts. To cover another shift on its own, create another schedule.",
      "shiftNotWorked": "Shift no longer worked",
      "shiftNotWorkedHint": "This position no longer works the chosen shift, so the schedule creates no rounds for it. Edit the schedule to choose another shift or all shifts.",
      "noPositionsBound": "None bound",
      "window": "Execution Window",
      "startDate": "Start Date",
      "endDate": "End Date",
      "active": "Active",
      "requiresApproval": "Requires Approval"
    },
    "form": {
      "createTitle": "New Schedule",
      "editTitle": "Edit Schedule",
      "previewNext": "Preview next 5 instances",
      "previewTitle": "Next scheduled instances",
      "intraShiftRepeat": "Repeat within shift",
      "intraShiftRepeatHint": "Optional — generate a round every N minutes within the shift. Leave blank for one round per shift.",
      "onDemandNote": "On-demand schedules are manual templates — operators start these rounds when needed. No shift, recurrence, or end date is required.",
      "dynamicNote": "Dynamic / ad-hoc rounds have no schedule. The round is dispatched on demand and must be explicitly assigned to operators to appear on mobile. No shift, recurrence, or dates are required.",
      "endDateCampaignHint": "Required for campaign schedules.",
      "endDateHint": "Calculated from recurrence end condition, or leave blank for no end date.",
      "campaignEndDateRequired": "Campaign schedules require an end date.",
      "projectionTitle": "Projected generation",
      "projectionSummary": "{{total}} rounds · {{perDate}} per date",
      "projectedRounds": "Rounds over the next 30 days",
      "roundsPerDate": "Rounds per scheduled date",
      "occurrenceDates": "Scheduled dates",
      "derivedWindows": "Round windows",
      "positionsWithoutShifts": "These positions work no active shift and cannot run this schedule: {{names}}",
      "stalePositionShift": "{{position}} no longer works the {{shift}} shift, so this schedule creates no rounds for it. Saving runs all the shifts it works now, unless you choose one.",
      "types": {
        "timeBased": "Time-Based",
        "onDemand": "On-Demand",
        "campaign": "Campaign",
        "dynamic": "Dynamic / Ad-hoc"
      },
      "slotAt": "{{date}} at {{time}}"
    },
    "adHoc": {
      "title": "Start Ad-Hoc Round",
      "create": "Create Round",
      "created": "Ad-hoc round created.",
      "shift": "Shift",
      "shiftDate": "Shift Date",
      "noGroup": "— No operational position —",
      "dueDate": "Due Date",
      "dueTime": "Due Time",
      "minutes": "minutes",
      "assignToOperator": "Assign to Operator (optional)",
      "noOperator": "— Any operator in position —",
      "resolvingVersion": "Resolving active round version…",
      "noActiveVersion": "This round has no active published version.",
      "fieldTestGroup": "Field Test (Validation Review)"
    },
    "recurrence": {
      "title": "Recurrence Pattern",
      "interval": "Interval",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "every": "Every",
      "minutes": "minutes",
      "days": "day(s)",
      "weeksOn": "week(s) on",
      "months": "month(s)",
      "everyYear": "Every year",
      "month": "Month",
      "onDay": "On day",
      "onThe": "On the",
      "timeOfDay": "Time of Day",
      "endCondition": "End",
      "noEndDate": "No end date",
      "endAfter": "End after",
      "occurrences": "occurrences",
      "endBy": "End by",
      "weeks": {
        "first": "first",
        "second": "second",
        "third": "third",
        "fourth": "fourth",
        "last": "last"
      },
      "summary": {
        "daily": "Every {{every}} day(s)",
        "everyDay": "Every day",
        "everyWeekdays": "Every weekday",
        "everyWeekends": "Every weekend",
        "daysEveryDay": "every day",
        "daysWeekdays": "weekdays",
        "daysWeekends": "weekends",
        "weeklyOne": "Every week",
        "weeklyOneOn": "Every week on {{days}}",
        "weekly": "Every {{every}} weeks on {{days}}",
        "weeklyAnyDay": "Every {{every}} weeks",
        "monthly": "Every {{every}} month(s)",
        "monthlyOnDay": "Every {{every}} month(s) on day {{day}}",
        "monthlyOnThe": "Every {{every}} month(s) on the {{when}}",
        "yearly": "Every year in {{month}}",
        "yearlyOnThe": "Every year on the {{when}} of {{month}}",
        "yearlyAny": "Every year",
        "endAfter": "ends after {{count}} occurrence(s)",
        "endBy": "ends by {{date}}"
      },
      "weekOptions": {
        "first": "First",
        "second": "Second",
        "third": "Third",
        "fourth": "Fourth",
        "last": "Last"
      }
    },
    "rounds": {
      "title": "Round Status Board",
      "startAdHoc": "Start Ad-Hoc Round",
      "overdue": "Overdue",
      "pending": "Pending",
      "inProgress": "In Progress",
      "completed": "Completed",
      "overdueTab": "Overdue",
      "pendingTab": "Pending",
      "inProgressTab": "In Progress",
      "completedTab": "Completed",
      "noOverdue": "No overdue rounds.",
      "nonePending": "No pending rounds.",
      "noneInProgress": "No rounds in progress.",
      "noneCompleted": "No completed rounds.",
      "updatedBadge": "Updated to v{{version}}",
      "updatedTooltip": "This round's round has changed since you last completed it. Review the changes before starting.",
      "dynamicRoundBadge": "Dynamic Round",
      "dynamicRoundTooltip": "This round was created as a corrective action.",
      "fields": {
        "round": "Round",
        "assignedTo": "Assigned To",
        "shift": "Shift",
        "scheduledFor": "Scheduled For",
        "dueBy": "Due By",
        "startedAt": "Started",
        "completedAt": "Completed"
      }
    },
    "calendar": {
      "title": "Calendar",
      "prevWeek": "Previous Week",
      "nextWeek": "Next Week",
      "prev": "Previous",
      "next": "Next",
      "today": "Today",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "more": "+{{count}} more",
      "suspended": "Suspended",
      "detail": {
        "suspensionReason": "Suspension reason",
        "previouslySuspended": "Previously suspended",
        "liftComment": "Lift comment"
      },
      "suspend": {
        "enter": "Suspend Rounds",
        "exit": "Exit Suspend Mode",
        "hint": "Select round occurrences (drag over items or days), then add a reason and Suspend — or select already-suspended ones and Lift.",
        "selectAll": "Select all in view",
        "clear": "Clear",
        "selectedCounts": "{{suspend}} to suspend · {{lift}} to lift",
        "reason": "Reason",
        "reasonPlaceholder": "Why are these occurrences being suspended?",
        "confirm": "Suspend",
        "lift": "Lift",
        "cancel": "Cancel",
        "success": "{{count}} occurrence(s) suspended.",
        "liftSuccess": "{{count}} suspension(s) lifted."
      },
      "viewMode": "View mode"
    },
    "status": {
      "notStarted": "Not Started",
      "inProgress": "In Progress",
      "completed": "Completed",
      "missed": "Missed"
    },
    "assignment": {
      "title": "Assignment Board",
      "unassigned": "Unassigned Rounds",
      "assignedRounds": "Assigned Rounds",
      "allAssigned": "All rounds are assigned.",
      "noneAssigned": "No assigned rounds.",
      "selectOperator": "Operator",
      "operatorId": "Operator ID",
      "selectNode": "Hierarchy Node",
      "date": "Date",
      "selectNodePrompt": "Select a hierarchy node to view rounds for assignment.",
      "assign": "Assign",
      "reassign": "Reassign",
      "reassignTo": "Reassign To",
      "assigned": "Round assigned successfully.",
      "reassigned": "Round reassigned successfully."
    },
    "workload": {
      "title": "Workload Heatmap",
      "group": "Operational Position",
      "shift": "Shift",
      "noData": "No workload data available.",
      "noRounds": "No rounds",
      "less": "Less",
      "more": "More",
      "metric": "Weight by",
      "metricRounds": "Rounds",
      "metricTasks": "Tasks",
      "metricDuration": "Duration",
      "tooltipRounds": "{{total}} total | {{done}} done | {{pending}} pending | {{missed}} missed",
      "tooltipTasks": "{{tasks}} tasks across {{total}} rounds",
      "tooltipDuration": "{{estimated}} planned",
      "tooltipActual": "{{actual}} actual",
      "noEstimate": "No duration estimate on these rounds"
    },
    "scheduleView": {
      "title": "Schedule View",
      "filters": "Filters",
      "filterNode": "Hierarchy Node",
      "filterGroup": "Assigned Operational Position",
      "filterType": "Schedule Type",
      "filterStatus": "Status",
      "filterRound": "Round",
      "all": "All",
      "apply": "Apply",
      "clear": "Clear",
      "projected": "Projected",
      "total": "Total",
      "real": "Real",
      "projectedCount": "Projected",
      "empty": "No scheduled rounds for this week.",
      "confirmCancel": "Are you sure you want to cancel this round?",
      "roundCancelled": "Round cancelled successfully.",
      "menu": {
        "viewDetails": "View Details",
        "editSchedule": "Edit Schedule",
        "startExecution": "Start Execution",
        "viewRound": "View Round",
        "cancelRound": "Cancel Round"
      },
      "detail": {
        "title": "Round Details",
        "round": "Round",
        "scheduleType": "Schedule Type",
        "hierarchyNode": "Hierarchy Node",
        "dueDate": "Due Date",
        "window": "Execution Window",
        "assignedPosition": "Assigned Operational Position",
        "assignedOperator": "Assigned Operator",
        "triggerSource": "Trigger Source",
        "noStatus": "N/A"
      }
    }
  },
  "execution": {
    "monitor": {
      "title": "Execution Monitor",
      "empty": "No executions found."
    },
    "detail": {
      "title": "Execution Detail",
      "steps": "Execution Steps",
      "response": "Response",
      "notes": "Notes",
      "backToList": "Back to Executions",
      "area": "Area / Unit",
      "totalSteps": "Total Steps",
      "completed": "Completed",
      "skipped": "Skipped",
      "photos": "Photos",
      "stepDescription": "Step Description",
      "type": "Type",
      "time": "Time",
      "review": "Console Operator Review",
      "reviewNote": "Console Operators can only view their own round executions. Approval/rejection requires Supervisor privileges.",
      "reviewComments": "Review Comments (optional)",
      "reviewCommentsPlaceholder": "Add review comments...",
      "approve": "Approve Execution",
      "reject": "Reject Execution",
      "reviewedAt": "Reviewed",
      "conditionallyHidden": "Conditionally hidden · optional",
      "stepTypes": {
        "measurement": "Measurement",
        "photo": "Photo",
        "freetext": "Freetext",
        "yesNo": "Yes/No",
        "passFail": "Pass/Fail",
        "signature": "Signature",
        "date": "Date",
        "selection": "Selection",
        "multiSelect": "Multi-select",
        "check": "Check"
      },
      "photosCaptured": "{{count}} photo(s) captured",
      "photoCaptured": "Photo captured",
      "signatureCaptured": "Signature captured",
      "acknowledged": "Acknowledged",
      "notAcknowledged": "Not acknowledged",
      "durationMinutes": "({{minutes}}m)",
      "durationHours": "({{hours}}h)",
      "durationHoursMinutes": "({{hours}}h {{minutes}}m)"
    },
    "review": {
      "title": "Review Queue",
      "empty": "No executions pending review.",
      "confirmReject": "Flag this round for follow-up? This is recorded against the completed round and cannot be undone.",
      "totalExecutions": "Total Executions",
      "completionRate": "Completion Rate",
      "pendingReview": "Pending Review",
      "totalReviewed": "Total Reviewed",
      "approvalRate": "Approval Rate",
      "avgCompletionTime": "Avg Completion Time"
    },
    "analytics": {
      "title": "Execution Oversight Analytics"
    },
    "history": {
      "title": "Execution History",
      "empty": "No historical executions found."
    },
    "fields": {
      "round": "Round",
      "assignedTo": "Operator",
      "status": "Status",
      "reviewStatus": "Review Status",
      "startedAt": "Started",
      "completedAt": "Completed",
      "progress": "Progress"
    }
  },
  "operationalPositionsShell": {
    "tabs": {
      "groups": "Operational Positions",
      "users": "Users"
    }
  },
  "userList": {
    "title": "Users & Operational Position Assignments",
    "empty": "No users found.",
    "noGroups": "No operational position assigned",
    "columns": {
      "name": "Name",
      "email": "Email",
      "groups": "Operational Positions",
      "status": "Status"
    }
  },
  "users": {
    "addUser": "Add User",
    "addEmployeeUser": "Add Employee User",
    "addPartnerUser": "Add Partner User",
    "partnerComingSoon": "Coming soon",
    "addPartnerUserComingSoon": "Add Partner User — available once Okta integration is in place",
    "createTitle": "Add People",
    "editTitle": "Edit User",
    "created": "User created.",
    "createdCount": "{{count}} user(s) added.",
    "updated": "User updated.",
    "deactivated": "User deactivated.",
    "deactivate": "Deactivate",
    "notFoundAfterApproval": "The approved user is not in the list yet. Refresh and assign their operational position.",
    "confirmDeactivate": "Are you sure you want to deactivate this user? They will lose access immediately.",
    "search": {
      "label": "Search Azure AD",
      "placeholder": "Search by name or email",
      "prompt": "Search the directory to find an employee to add.",
      "searching": "Searching…",
      "noResults": "No matching directory users found.",
      "error": "Directory search failed. Please try again.",
      "selectedLabel": "Selected employee",
      "clear": "Change",
      "columns": {
        "name": "Name",
        "email": "Email",
        "title": "Title",
        "location": "Location"
      }
    },
    "fields": {
      "azureAdObjectId": "Azure AD Object ID",
      "azureAdObjectIdPlaceholder": "00000000-0000-0000-0000-000000000000",
      "azureAdObjectIdHint": "The user's Azure AD object ID (oid). This links the account to their enterprise identity.",
      "displayName": "Display Name",
      "email": "Email",
      "people": "People",
      "pendingSummary": "{{count}} membership(s) will be created. People who already hold a position keep it.",
      "groups": "Operational Positions",
      "groupsHint": "Assign at least one operational position. Each grants its associated system roles.",
      "addGroup": "Search and add an operational position…",
      "allBusinessUnits": "All Business Units",
      "noGroups": "No operational positions assigned yet.",
      "isActive": "Active"
    }
  },
  "operationalPositions": {
    "title": "Operational Positions",
    "openRole": "Open this role in System Roles",
    "openGroup": "Open this operational position for editing",
    "searchPlaceholder": "Search by position, role, or user...",
    "empty": "No operational positions found. Create one to get started.",
    "confirmDeactivate": "Are you sure you want to deactivate the operational position \"{{name}}\"?",
    "actions": {
      "create": "Create Operational Position",
      "members": "Members",
      "deactivate": "Deactivate"
    },
    "columns": {
      "name": "Name",
      "role": "Role",
      "nodes": "Nodes",
      "shift": "Shift",
      "members": "Members",
      "status": "Status",
      "actions": "Actions"
    },
    "fields": {
      "name": "Operational Position Name",
      "description": "Description",
      "role": "Role",
      "roles": "System Roles",
      "nodes": "Hierarchy Nodes",
      "shift": "Shift",
      "shifts": "Shifts",
      "parentPosition": "Escalation Parent",
      "businessUnit": "Business Unit",
      "isActive": "Active"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "form": {
      "createTitle": "Create Operational Position",
      "editTitle": "Edit Operational Position",
      "namePlaceholder": "Enter operational position name",
      "descriptionPlaceholder": "Optional description",
      "nameRequired": "Operational position name is required.",
      "roleRequired": "At least one system role is required.",
      "roleReadOnly": "Role cannot be changed after creation.",
      "searchRoles": "Search roles…",
      "noRolesFound": "No roles match your search.",
      "selectNodes": "Select Nodes",
      "noNodesSelected": "None selected.",
      "noShift": "Does not work shifts",
      "shiftHint": "Leave empty if this position does not work shifts.",
      "businessUnitHint": "With no hierarchy nodes the position covers this whole Business Unit. Select nodes instead and it joins their Business Unit.",
      "addShift": "Add New Shift",
      "noParent": "None — falls back to Business Unit administrators.",
      "noParentCandidates": "No positions at or above the selected nodes.",
      "parentNeedsNodes": "Select hierarchy nodes first.",
      "enterpriseNoNodes": "Enterprise-scoped roles cannot be assigned to hierarchy nodes."
    },
    "parentPicker": {
      "title": "Select Escalation Positions",
      "intro": "Escalation never travels downward. Pick any positions on this position's own nodes or above them — all of them are paged at the same time.",
      "selectParent": "Select Positions",
      "search": "Search positions…",
      "ownNode": "This position's node",
      "levelsAbove": "{{count}} level(s) above",
      "noPositions": "No eligible positions on this node.",
      "noSearchResults": "No positions match your search.",
      "noneHint": "Clears every selected position.",
      "empty": "Select hierarchy nodes first — the ladder is built from them.",
      "apply": "Select"
    },
    "members": {
      "title": "Manage Members",
      "searchLabel": "Add Member",
      "searchPlaceholder": "Search by name or email...",
      "listLabel": "Current Members",
      "noResults": "No users found.",
      "empty": "No members in this operational position yet."
    },
    "nodePicker": {
      "title": "Select Hierarchy Nodes",
      "intro": "Assign at any level — for example Unit for an Operator, Area for a Head Operator, or the top of the Business Unit for a BU-wide role.",
      "selectedCount": "{{count}} node(s) selected",
      "parentTag": "parent",
      "empty": "No hierarchy nodes available.",
      "apply": "Apply"
    }
  },
  "exceptions": {
    "queue": {
      "title": "Exception Queue",
      "critical": "Critical",
      "noExceptions": "No exceptions found."
    },
    "aged": {
      "badge": "Aged",
      "tooltip": "Carried over more than 3 shifts"
    },
    "detail": {
      "title": "Exception Detail",
      "notFound": "Exception not found.",
      "info": "Exception Info",
      "resolve": "Resolve",
      "confirmResolve": "Are you sure you want to resolve this exception?",
      "resolvedSuccess": "Exception resolved.",
      "resolvedAt": "Resolved At",
      "resolvedBy": "Resolved By",
      "resolutionNotes": "Resolution Notes",
      "addCorrectiveAction": "Add Corrective Action",
      "correctiveActions": "Corrective Actions",
      "noCorrectiveActions": "No corrective actions yet.",
      "caPathLabels": {
        "internal": "Internal",
        "eamWorkOrder": "EAM Work Order",
        "dynamicRounds": "Dynamic Round",
        "task": "Task"
      },
      "caDueDate": "Due",
      "caWorkOrder": "Work Order",
      "caReference": "Reference",
      "caLinkedRound": "Linked Round",
      "caCompletedAt": "Completed",
      "caDetailTitle": "Corrective Action Details",
      "raisedBySystem": "Raised by system",
      "caCreated": "Created",
      "caVersion": "Version",
      "caRoundStatus": "Round Status",
      "caTriggerSource": "Trigger Source",
      "caRoundError": "Could not load the linked round.",
      "caNoRound": "No linked round found.",
      "caExecutionDetails": "Execution Details",
      "caExecutionsError": "Could not load executions.",
      "caNoExecutions": "No executions for this round yet.",
      "escalations": "Escalation History",
      "noEscalations": "No escalations recorded.",
      "review": "Review"
    },
    "review": {
      "dialogTitle": "Review Exception",
      "currentStatus": "Current Status",
      "newStatus": "New Status",
      "options": {
        "carryForward": "Carrying Forward"
      },
      "resolutionNotes": "Resolution Notes",
      "resolutionNotesPlaceholder": "Describe how the exception was resolved...",
      "justification": "Justification",
      "justificationPlaceholder": "Reason for closing without further action...",
      "justificationOptional": "A corrective action or work order is linked; justification is optional.",
      "noTransitions": "This exception is in a terminal state and cannot be changed.",
      "submit": "Update Status",
      "updated": "Exception status updated."
    },
    "filter": {
      "all": "All",
      "open": "Open",
      "inProgress": "In Progress",
      "resolved": "Resolved",
      "allSeverities": "All Severities",
      "statusLabel": "Status:",
      "severityLabel": "Severity:"
    },
    "severity": {
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "status": {
      "open": "Open",
      "acknowledged": "Acknowledged",
      "inprogress": "In Progress",
      "resolved": "Resolved",
      "closed": "Closed",
      "carriedforward": "Carried Forward"
    },
    "table": {
      "severity": "Severity",
      "description": "Description",
      "location": "Location",
      "raisedBy": "Raised By",
      "raisedAt": "Raised At",
      "status": "Status",
      "actions": "Actions"
    },
    "correctiveAction": {
      "dialogTitle": "New Corrective Action",
      "path": "Path",
      "description": "Description",
      "descriptionPlaceholder": "Describe the corrective action...",
      "comments": "Comments",
      "commentsPlaceholder": "Add any additional comments...",
      "saveComments": "Save Comments",
      "commentsSaved": "Comments saved.",
      "markComplete": "Mark Complete",
      "verify": "Verify",
      "markedComplete": "Corrective action marked complete.",
      "verified": "Corrective action verified.",
      "confirmStatusChangeTitle": "Change Status",
      "confirmStatusChange": "This corrective action's status will change to \"{{status}}\". Do you want to continue?",
      "assignedTo": "Assigned To",
      "assignedToPlaceholder": "Search by name...",
      "dueDate": "Due Date",
      "created": "Corrective action created.",
      "statusCompleted": "Completed",
      "statusVerified": "Verified"
    },
    "escalation": {
      "acknowledged": "Acknowledged",
      "pending": "Pending"
    }
  },
  "shiftLog": {
    "chat": {
      "open": "Shift chat",
      "unreadMentions": "You have {{count}} unread mention(s)",
      "popOut": "Pop out",
      "popOutHint": "Keep the chat on top of other apps"
    },
    "title": "Shift Log",
    "historyTitle": "Notes History",
    "addEntry": "Add Log Entry",
    "entryAdded": "Shift log entry added.",
    "viewSource": "View Source",
    "viewAttachment": "View Attachment",
    "noActiveShift": "No active shift. Shift-log entries appear once a shift is active.",
    "noHistory": "You have not authored any shift notes yet.",
    "shift": "Shift",
    "activeTag": "Active",
    "endedTag": "Ended",
    "columns": {
      "time": "Time",
      "category": "Category",
      "node": "Location",
      "entry": "Entry",
      "by": "By",
      "actions": "Actions"
    },
    "nodeLevel": {
      "site": "Site"
    },
    "filters": {
      "category": "Category",
      "allCategories": "All Categories",
      "personnel": "Personnel",
      "allPersonnel": "All Personnel",
      "searchPlaceholder": "Search entries..."
    },
    "form": {
      "notesHeading": "Enter Shift Notes",
      "notes": "Shift Notes",
      "notesPlaceholder": "Enter one note per line, e.g.:\nPump P-101A vibration high — investigated, no action required\nHSE — toolbox talk completed at 06:30\nUnit 3 startup deferred to 10:00 per Supervisor",
      "notesHint": "One note per line for AI auto-classification, or a single note for manual entry.",
      "generateAi": "Auto-classify with AI",
      "classifying": "Classifying...",
      "comingSoon": "Voice & camera capture coming soon",
      "voiceCapture": "Voice capture (coming soon)",
      "cameraCapture": "Camera capture (coming soon)",
      "submit": "Add Note",
      "title": "Title",
      "titlePlaceholder": "Entry title...",
      "body": "Details",
      "bodyPlaceholder": "Additional details...",
      "category": "Category",
      "categoryHint": "Override the AI-suggested category, or choose one manually.",
      "area": "Area / Unit",
      "areaNone": "None (no unit)",
      "areaHint": "Tag the unit (Level 5) or area (Level 4) this note relates to.",
      "tags": "Tags",
      "tagsPlaceholder": "Comma-separated tags...",
      "equipment": "Equipment",
      "none": "None"
    },
    "noEntries": "No log entries for this shift.",
    "immutable": "This entry is locked and cannot be modified.",
    "deleteConfirm": "Delete this shift log entry? This action cannot be undone.",
    "deleteSuccess": "Entry deleted.",
    "edit": {
      "title": "Edit Note",
      "saved": "Note updated."
    },
    "systemAuthor": "System",
    "systemAuthorWithSource": "System ({{source}})"
  },
  "shiftNotes": {
    "title": "Shift Notes",
    "save": "Save Note",
    "saving": "Saving...",
    "added": "{{count}} note(s) added.",
    "critical": "Critical",
    "hint": "Notes are sorted into handover sections automatically.",
    "hintWithNode": "Tagged to {{node}}. Sorted into handover sections automatically.",
    "noShift": "Start your shift to capture notes.",
    "placeholder": "What happened this shift? Type @ to mention a position or a person.",
    "attachmentImagesOnly": "Only images can be attached",
    "attachmentTooLarge": "File exceeds the 25 MB limit.",
    "attachmentFailed": "Attachment upload failed.",
    "tools": {
      "critical": "Flag as critical",
      "camera": "Take a photo",
      "attach": "Attach a file",
      "removeAttachment": "Remove attachment",
      "voiceSoon": "Voice capture — not available yet, planned for a future release",
      "cameraSoon": "Photo capture — not available yet, planned for a future release"
    }
  },
  "handoverShell": {
    "title": "Shift Handover",
    "tabs": {
      "shiftLog": "Shift Notes",
      "startOfShift": "Start of Shift",
      "notesHistory": "Notes History",
      "shiftHandover": "Shift Handover",
      "pendingApprovals": "Pending Approvals",
      "areaRollup": "Area Roll-Up",
      "handovers": "Handovers",
      "assemble": "Auto-Assemble",
      "rotation": "Rotation"
    }
  },
  "operatorHandover": {
    "list": {
      "title": "Handover Reports",
      "shift": "Shift",
      "date": "Date",
      "from": "From",
      "to": "To",
      "statusFilter": "Status",
      "noShift": "No active or recently-ended shifts available for handover.",
      "generate": "Generate Hand-over Report",
      "generated": "{{count}} handover report(s) generated.",
      "generatedEmpty": "Nothing to generate — no operators ran rounds or entered notes for this shift yet.",
      "empty": "No handover reports match the current filters.",
      "operator": "Operator",
      "items": "Items",
      "status": "Status",
      "open": "Open"
    },
    "status": {
      "Draft": "Draft",
      "Finalized": "Finalized",
      "PendingApproval": "Pending Approval",
      "FullyAcknowledged": "Fully Acknowledged"
    },
    "generate": {
      "title": "Generate Hand-over Report",
      "hint": "Select a shift to assemble (or re-assemble) its per-operator handover reports.",
      "empty": "No active or recently-ended shifts available.",
      "assemble": "Assemble",
      "reassemble": "Re-assemble",
      "assembled": "Assembled",
      "done": "{{count}} report(s) assembled."
    },
    "detail": {
      "title": "Handover Report",
      "notFound": "Handover report not found.",
      "draftBadge": "Draft",
      "finalizedBadge": "Finalized",
      "reassemble": "Re-assemble",
      "reassembled": "Report re-assembled",
      "busy": "Working… please wait",
      "pdfFileName": "Handover Report - {{operator}}",
      "finalize": "Finalize",
      "approveSubmit": "Approve & Submit",
      "finalized": "Report finalized",
      "acknowledge": "Acknowledge",
      "acknowledged": "Report acknowledged",
      "shiftNotes": "Shift Notes",
      "colTime": "Time",
      "colEntry": "Entry",
      "colBy": "By",
      "submit": "Submit",
      "commentsTitle": "Handover Comments",
      "commentsPlaceholder": "Any additional context for the incoming operator...",
      "commentarySaved": "Handover comments saved.",
      "editItemTitle": "Edit Note",
      "editItemText": "Note",
      "editItemCategory": "Category",
      "verbalWalkthrough": "Verbal walkthrough completed",
      "verbalRequired": "The verbal walkthrough must be completed before finalizing.",
      "outgoingAck": "Outgoing acknowledged",
      "incomingAcks": "Incoming acknowledgements",
      "aiCurrent": "Current Shift — AI Summary",
      "aiPrevious": "Previous Shift — AI Summary",
      "aiHeading": "AI-Assisted Summary",
      "noItems": "No items in this section.",
      "addItem": "Add",
      "addItemPlaceholder": "Add a note to this section…",
      "moveTo": "Move to",
      "items": "items",
      "stepNotes": "Shift Notes Entered",
      "stepGenerated": "Handover Generated",
      "stepReview": "Review & Edit Content",
      "stepApprove": "Approve & Submit",
      "bulkHelp": "Enter one note per line, then click \"Auto-classify with AI\" to sort each into the right section — or choose a section and click \"Add Note\" for a single entry. Tag the area/unit it relates to.",
      "notesClassified": "Notes classified and added to the handover.",
      "carryOverTitle": "Carry-Over Items",
      "carryOverEmpty": "No carry-over items from the previous shift.",
      "carryOverNote": "Shown at shift level (per-operator scoping pending) — validate before sign-off.",
      "cfType": "Type",
      "cfItem": "Item",
      "cfDetail": "Detail",
      "cfException": "Exception",
      "cfAction": "Corrective Action",
      "cfExecution": "Paused Round",
      "signOffTitle": "Sign-Off",
      "signOffNote": "Sign-off requirements are configurable by business unit.",
      "previousReportsTitle": "Previous Reports",
      "previousReportsEmpty": "You have no other handover reports.",
      "prShift": "Shift",
      "prDate": "Date",
      "prItems": "Items",
      "prStatus": "Status"
    },
    "rollup": {
      "title": "Area Roll-Up",
      "acknowledge": "Acknowledge",
      "acknowledged": "Roll-up acknowledged",
      "empty": "No reports in this area.",
      "previousAcks": "Previous acknowledgements",
      "generatePrompt": "Pick an area, shift and the sections you want to see, then select Generate to build the roll-up.",
      "generate": "Generate Roll-Up",
      "reset": "Reset / New Report",
      "pdfFileName": "Roll-Up Handover Report",
      "shiftLabel": "Shift",
      "shiftRequired": "Required — the roll-up is shift-scoped.",
      "sectionsLabel": "Sections",
      "sectionsHint": "Leave empty to include all sections.",
      "commentTitle": "Roll-Up Comment",
      "commentLabel": "Comment",
      "commentPlaceholder": "Add a comment for this roll-up...",
      "saveComment": "Save Comment",
      "commentSaved": "Comment saved",
      "commentEmpty": "No comment has been added for this roll-up.",
      "allUnits": "All Units",
      "noNotesForCategory": "No shift notes for this category."
    },
    "review": {
      "selectPrompt": "Select an area from the tree to review its rolled-up handover.",
      "showSections": "Show sections:",
      "unassigned": "Unassigned",
      "noVisibleSections": "No items match the selected sections.",
      "ackTitle": "Reports in this area"
    },
    "units": {
      "unit": "Unit",
      "area": "Area",
      "unassigned": "Unassigned",
      "level": "Level {{level}}"
    },
    "pending": {
      "title": "Pending Approvals",
      "hint": "Handover reports that have been assembled but are not yet fully acknowledged, across recent shifts.",
      "empty": "No reports are awaiting approval.",
      "shift": "Shift",
      "date": "Date",
      "operator": "Operator",
      "items": "Items",
      "status": "Status",
      "open": "Open"
    },
    "areaRollup": {
      "title": "Area Roll-Up",
      "hint": "Select a node from the hierarchy to review and acknowledge the rolled-up handover for that area and everything beneath it.",
      "hierarchyTree": "Hierarchy Tree",
      "selectArea": "Select area",
      "open": "Open Roll-Up",
      "noAreas": "No facility areas available."
    }
  },
  "handover": {
    "history": {
      "title": "Handover History",
      "createNew": "New Handover",
      "noRecords": "No handover records found.",
      "type": "Type",
      "authoredBy": "Authored By",
      "authoredAt": "Authored At",
      "status": "Status",
      "acknowledged": "Acknowledged"
    },
    "editor": {
      "title": "Handover Editor",
      "autoAssemble": "Auto-Assemble",
      "assembled": "Handover auto-assembled from shift data.",
      "finalize": "Finalize",
      "finalized": "Handover finalized.",
      "noSectionsToSave": "No saved sections to update yet.",
      "sectionTitle": "Section Title",
      "sectionContent": "Content",
      "addSection": "Add Section",
      "newSection": "New Section",
      "mandatory": "Mandatory section",
      "complete": "Complete",
      "empty": "Empty"
    },
    "autoAssembled": {
      "title": "Auto-Assembled Handover",
      "refresh": "Refresh Assembly",
      "success": "Handover auto-assembled successfully.",
      "noContent": "No content for this section.",
      "noSections": "No assembled sections available.",
      "authoredBy": "Authored By",
      "authoredAt": "Authored At",
      "readOnly": "Read-only Fact Card"
    },
    "assembly": {
      "title": "Assemble Shift Handover",
      "subtitle": "Pick a recently-ended shift to auto-assemble its handover.",
      "shift": "Shift",
      "ended": "Ended",
      "businessDate": "Business Date",
      "hasHandover": "Handover exists",
      "assemble": "Assemble",
      "view": "View",
      "noShifts": "No recently-ended shifts found.",
      "assembled": "Handover assembled.",
      "assembleFailed": "Could not assemble the handover for this shift."
    },
    "acknowledge": {
      "title": "Acknowledge Handover",
      "subtitle": "Review and accept the incoming handover.",
      "authoredBy": "Authored By",
      "authoredAt": "Authored At",
      "sections": "Sections",
      "accept": "Acknowledge & Accept",
      "success": "Handover acknowledged successfully.",
      "alreadyAcknowledged": "Acknowledged by",
      "progress": "{{count}} of {{total}} operators acknowledged",
      "fullyAcknowledged": "Fully acknowledged",
      "youAcknowledged": "You have acknowledged this handover.",
      "notRequired": "Digital acknowledgement is not required for this business unit.",
      "notes": "Post-Finalization Notes",
      "noNotes": "No notes added.",
      "addNote": "Add Note",
      "noteAdded": "Note added."
    },
    "rotation": {
      "title": "Rotation Handover Summary",
      "empty": "No rotation handover data available.",
      "totalShifts": "Total Shifts in Rotation",
      "noSections": "No sections in this handover."
    },
    "ai": {
      "generateDraft": "Generate AI Draft",
      "generating": "Generating AI summary...",
      "retry": "Retry",
      "draftTitle": "AI-Generated Draft",
      "badge": "AI Generated",
      "editPlaceholder": "Edit the generated draft...",
      "accept": "Accept Draft",
      "discard": "Discard",
      "errorGenerating": "Failed to generate AI summary.",
      "accepted": "AI draft accepted."
    },
    "carryForward": {
      "title": "Carry-Forward Items",
      "noItems": "No carry-forward items for this shift.",
      "acknowledge": "Acknowledge Items",
      "acknowledged": "Carry-forward items acknowledged.",
      "acknowledgedStatus": "Acknowledged",
      "openExceptions": "Open Exceptions",
      "correctiveActions": "Incomplete Corrective Actions",
      "pausedExecutions": "Paused Executions",
      "shiftsOpen": "Open for {{count}} shifts",
      "due": "Due"
    },
    "status": {
      "draft": "Draft",
      "finalized": "Finalized",
      "notAcknowledged": "Pending"
    }
  },
  "startOfShift": {
    "title": "Start of Shift",
    "notYetAcknowledged": "No start-of-shift record for the current shift.",
    "acknowledge": "Acknowledge Shift Start",
    "acknowledged": "Shift start acknowledged.",
    "rounds": "Today's Rounds",
    "complete": "complete",
    "openExceptions": "Open Exceptions",
    "exceptionsPending": "requiring attention",
    "acknowledgedAt": "Acknowledged",
    "conducted": "Start-of-Shift",
    "correctiveActions": "Outstanding Corrective Actions",
    "shiftsOpen": "shift(s) open",
    "persistent": "Persistent",
    "due": "Due",
    "dataUnavailable": "Data Unavailable — {{source}}",
    "carriedForward": "Carried Forward Items",
    "participantAdded": "Participant recorded.",
    "participants": {
      "title": "Participant Attendance",
      "name": "Operator",
      "namePlaceholder": "Select operator...",
      "role": "Role",
      "time": "Recorded At",
      "add": "Add Participant",
      "empty": "No participants logged yet."
    }
  },
  "reporting": {
    "scheduler": {
      "title": "Report Scheduler",
      "activeSchedules": "Scheduled Reports",
      "allReports": "All Reports",
      "noSchedules": "No scheduled reports.",
      "noReports": "No reports available.",
      "recipients": "Recipients",
      "noRecipients": "No recipients",
      "reportType": "Report Type",
      "addSchedule": "Add Schedule"
    },
    "period": "Period",
    "noData": "No report data available.",
    "exportExcel": "Export Excel",
    "exportPdf": "Export PDF",
    "allNodes": "All Locations",
    "startDate": "Start Date",
    "endDate": "End Date",
    "apply": "Apply",
    "periods": {
      "last7Days": "Last 7 Days",
      "last30Days": "Last 30 Days",
      "last90Days": "Last 90 Days",
      "mtd": "Month to Date",
      "ytd": "Year to Date",
      "custom": "Custom Range"
    },
    "compliance": {
      "title": "Compliance Report",
      "totalRounds": "Total Rounds",
      "completedRounds": "Completed",
      "missedRounds": "Missed",
      "completionRate": "Completion Rate",
      "overallCompliance": "Overall Compliance",
      "breakdown": "Breakdown by Location",
      "node": "Location",
      "total": "Total",
      "completed": "Completed",
      "missed": "Missed",
      "rate": "Rate",
      "progress": "Progress",
      "completionBreakdown": "Completion Breakdown",
      "byNode": "Compliance by Location"
    },
    "exceptions": {
      "title": "Exception Analytics",
      "total": "Total Exceptions",
      "open": "Open",
      "critical": "Critical",
      "avgResolution": "Avg. Resolution",
      "bySeverity": "By Severity",
      "byLocation": "By Location",
      "openVsResolved": "Open vs Resolved",
      "resolved": "Resolved"
    },
    "executive": {
      "title": "Executive Summary",
      "generatedAt": "Generated",
      "businessUnits": "Business Units",
      "rounds": "Total Rounds",
      "byBU": "By Business Unit",
      "businessUnit": "Business Unit",
      "buComparison": "Business Unit Comparison"
    },
    "handover": {
      "title": "Handover Metrics Report",
      "noData": "No handover metrics available.",
      "totalHandovers": "Total Handovers",
      "finalized": "Finalized",
      "acknowledged": "Acknowledged",
      "ackRate": "Acknowledgement Rate",
      "meanTimeToAck": "Mean Time to Acknowledge",
      "carryForward": "Carry-Forward Items",
      "statusBreakdown": "Handover Status Breakdown",
      "pending": "Pending"
    },
    "cooMv": {
      "title": "COO M&V Dashboard",
      "noData": "No compliance data available.",
      "overallCompliance": "Overall COO Compliance",
      "standard": "Standard",
      "element": "Element",
      "compliance": "Compliance %",
      "status": "Status",
      "noElements": "No compliance elements found.",
      "complianceByElement": "Compliance by Element"
    },
    "custom": {
      "title": "Custom Reports",
      "newReport": "New Report",
      "editReport": "Edit Report",
      "noReports": "No custom reports found.",
      "run": "Run",
      "results": "Results",
      "noResults": "No results found.",
      "columns": {
        "name": "Name",
        "reportType": "Report Type",
        "createdOn": "Created"
      },
      "fields": {
        "name": "Report Name",
        "namePlaceholder": "Enter report name",
        "description": "Description",
        "reportType": "Report Type",
        "dateFrom": "Date From",
        "dateTo": "Date To"
      },
      "types": {
        "rounds": "Rounds",
        "exceptions": "Exceptions",
        "handovers": "Handovers",
        "correctiveActions": "Corrective Actions",
        "shiftLog": "Shift Log"
      }
    },
    "savedReports": {
      "title": "Saved Reports",
      "empty": "No saved reports. Save a report configuration from any report page.",
      "columns": {
        "name": "Name",
        "type": "Report Type",
        "scheduled": "Scheduled",
        "lastSent": "Last Sent",
        "shared": "Shared"
      },
      "actions": {
        "schedule": "Schedule"
      },
      "schedule": {
        "title": "Schedule Report",
        "enabled": "Enable scheduled delivery",
        "preset": "Frequency Preset",
        "cron": "Cron Expression",
        "recipients": "Recipients",
        "recipientsHint": "Comma-separated email addresses",
        "weekdayMorning": "Weekday mornings (6 AM)",
        "weeklyMonday": "Weekly (Monday 6 AM)",
        "monthlyFirst": "Monthly (1st, 6 AM)",
        "custom": "Custom"
      }
    }
  },
  "notifications": {
    "panel": {
      "title": "Notifications",
      "empty": "No notifications available.",
      "markAllRead": "Mark all as read"
    },
    "preferences": {
      "title": "Notification Preferences",
      "empty": "No notification preferences configured.",
      "type": "Notification Type",
      "inApp": "In-App",
      "email": "Email"
    }
  },
  "registration": {
    "title": "Request Access",
    "description": "You are authenticated but do not yet have access to this application. Please submit a request below and a BU Administrator will review it.",
    "displayName": "Display Name",
    "email": "Email",
    "businessUnit": "Business Unit",
    "selectBusinessUnit": "Select your Business Unit",
    "locationLoading": "Loading locations...",
    "hierarchyLevel": "Hierarchy Level",
    "roles": "Desired Roles",
    "submit": "Submit Request",
    "submitError": "Failed to submit access request. Please try again.",
    "levels": {
      "Enterprise": "Enterprise",
      "BU": "Business Unit",
      "Site": "Site / Facility",
      "Area": "Area",
      "Unit": "Unit"
    },
    "roleNames": {
      "BUAdministrator": "BU Administrator",
      "Engineer": "Engineer",
      "MaintenancePlanner": "Maintenance Planner",
      "FieldOperator": "Field Operator",
      "ConsoleOperator": "Console Operator",
      "Supervisor": "Supervisor",
      "IOCMember": "IOC Member",
      "ReadOnly": "Read Only",
      "ChangeManager": "Change Manager",
      "SafetyOfficer": "Safety Officer",
      "DataConsumer": "Data Consumer",
      "Auditor": "Auditor",
      "ITAdmin": "IT Admin"
    },
    "pending": {
      "title": "Access Request Pending",
      "message": "Your access request has been submitted and is awaiting approval from a BU Administrator. You will be notified when it is reviewed.",
      "status": "Status",
      "requestedAt": "Requested At",
      "location": "Location",
      "reviewNotes": "Review Notes",
      "cancelRequest": "Cancel Request",
      "cancelSuccess": "Access request cancelled successfully.",
      "cancelError": "Failed to cancel access request. Please try again.",
      "checkAgain": "Check Again",
      "requestAgain": "Request Access Again",
      "noRequest": "No access request found. You can submit a new one.",
      "buAdminContacts": "BU Administrators — contact them for questions",
      "statusTitle": {
        "Pending": "Access Request Pending",
        "Approved": "Access Request Approved",
        "Rejected": "Access Request Rejected",
        "Cancelled": "Access Request Cancelled"
      },
      "statusMessage": {
        "Pending": "Your access request has been submitted and is awaiting approval from a BU Administrator.",
        "Approved": "Your access has been approved, but you don't have any permissions assigned yet. Please contact one of your BU Administrators below to get set up, or check again once you've been assigned a role.",
        "Rejected": "Your access request has been rejected. You may submit a new request if needed.",
        "Cancelled": "Your access request was cancelled. You may submit a new request."
      }
    }
  },
  "accessRequests": {
    "title": "Access Requests",
    "empty": "No pending access requests.",
    "columns": {
      "displayName": "Name",
      "email": "Email",
      "hierarchyLevel": "Hierarchy Level",
      "requestedRoles": "Requested Roles",
      "status": "Status",
      "requestedAt": "Requested",
      "actions": "Actions"
    },
    "actions": {
      "refresh": "Refresh"
    },
    "review": {
      "rejectTitle": "Reject Access Request",
      "notes": "Review Notes",
      "notesPlaceholder": "Add optional notes..."
    },
    "messages": {
      "approved": "Access request approved successfully.",
      "rejected": "Access request rejected."
    }
  },
  "factCard": {
    "lastSynced": "Last synced",
    "viewInSource": "View in Source",
    "openInSource": "Open in source system"
  },
  "admin": {
    "home": {
      "title": "Administration",
      "subtitle": "Manage business-unit configuration and settings.",
      "changeClassificationDesc": "Define how round changes are auto-classified as Minor or Major.",
      "changeRequestFieldsDesc": "Add your own questions to the change request form, per request type.",
      "suspensionsDesc": "Suspend rounds or whole areas for a period — turnarounds, shutdowns and maintenance.",
      "hceRulesDesc": "Configure Health, Criticality and Environment asset-verification rules.",
      "platformAdminsDesc": "See which positions grant platform administration across Business Units, and who holds them.",
      "unitsOfMeasureDesc": "Maintain the standardized units of measure available when authoring rounds.",
      "shiftConfigDesc": "Manage shift patterns and rotation settings.",
      "crewsDesc": "Define the crews used by the rotation calendar and round-load planning.",
      "rotationDesc": "Configure the crew rotation schedule and view it on a calendar.",
      "correctiveActionPathRulesDesc": "Set the default corrective-action path (internal vs work order) per exception severity.",
      "retentionDesc": "Set data retention periods per record type and manage legal holds.",
      "sweepsDesc": "Check that the scheduled background sweeps are running, and force one that is not.",
      "handoverTemplatesDesc": "Configure the handover sections operators complete each shift, including mandatory sections.",
      "aiPromptTemplatesDesc": "Edit the AI prompts used to auto-classify shift notes — wording, rules and output format — without a code release.",
      "settingsDesc": "Configure BU-level behavior flags and thresholds (handover, execution, change management).",
      "auditLogDesc": "Search and review the immutable audit trail of all state-changing actions.",
      "notificationPreferencesDesc": "Choose which notifications you receive in-app and by email, per notification type.",
      "hierarchy": "Location Hierarchy",
      "hierarchyDesc": "Configure the site location hierarchy and operator assignments.",
      "equipment": "Equipment Registry",
      "equipmentDesc": "Manage equipment records and high-consequence flags.",
      "equipmentTypesDesc": "Maintain the equipment types used to classify assets, such as Well.",
      "operationalPositions": "Operational Positions",
      "operationalPositionsDesc": "Manage operational positions, roles and node assignments.",
      "users": "Users",
      "usersDesc": "Create and manage user accounts for this business unit.",
      "accessRequests": "Access Requests",
      "searchPlaceholder": "Search settings by name or description…",
      "rolesDesc": "Define system roles and the permissions granted to each.",
      "accessRequestsDesc": "Review and approve pending access requests.",
      "crewsRotationDesc": "Define crews and configure the rotation schedule and calendar."
    },
    "handoverTemplates": {
      "title": "Handover Section Templates",
      "hint": "These sections appear on every handover for this business unit. Mandatory sections must be filled before a handover can be finalized. Definitions and keywords drive AI auto-classification of shift notes.",
      "addCustom": "Add Custom Section",
      "editSection": "Edit Section",
      "sectionTitle": "Section Title",
      "definition": "Definition",
      "definitionPlaceholder": "Describe what belongs in this section",
      "keywords": "Keywords",
      "keywordsPlaceholder": "Add a keyword and press Enter",
      "keywordsHint": "Keywords seed AI auto-classification of shift notes.",
      "priorityAiOrder": "AI Priority Order",
      "priorityAiOrderHint": "Lower number wins when a note matches several sections.",
      "mandatory": "Mandatory",
      "active": "Active",
      "inactive": "Inactive",
      "order": "Order",
      "type": "Type",
      "custom": "Custom",
      "default": "Default",
      "status": "Status",
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "deactivated": "Section deactivated.",
      "reactivated": "Section reactivated.",
      "deleteTitle": "Delete Section",
      "deleteConfirm": "Delete \"{{name}}\"? It will no longer appear on new handover reports. Existing reports are unaffected.",
      "deleted": "Section deleted.",
      "saved": "Handover template saved.",
      "empty": "No handover sections configured."
    },
    "templateCategories": {
      "title": "Task Template Categories",
      "hint": "Authors file every saved task template under one of these categories, so the template library stays browsable as it grows.",
      "add": "Add Category",
      "edit": "Edit Category",
      "name": "Name",
      "description": "Description",
      "sortOrder": "Order",
      "templateCount": "Templates",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "empty": "No template categories configured yet.",
      "saved": "Category saved.",
      "confirmDelete": "Delete \"{{name}}\"? Categories that still have templates cannot be deleted.",
      "deleteFailed": "The category could not be deleted. It may still have templates filed under it."
    },
    "equipmentTypes": {
      "title": "Equipment Types",
      "hint": "Classify equipment by kind. The Databricks import files new assets as Well, or Unknown when the source gives no lift type — renaming either of those makes the import create it again.",
      "add": "Add Equipment Type",
      "edit": "Edit Equipment Type",
      "name": "Name",
      "equipmentCount": "Equipment",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "inactiveHint": "An inactive type stays on the equipment that already has it, but is no longer offered.",
      "empty": "No equipment types configured yet.",
      "saved": "Equipment type saved.",
      "confirmDelete": "Delete \"{{name}}\"? Types still assigned to equipment cannot be deleted — deactivate them instead.",
      "deleteFailed": "The equipment type could not be deleted. It may still be assigned to equipment."
    },
    "aiPromptTemplates": {
      "title": "AI Prompt Templates",
      "hint": "These prompts drive AI classification of shift and handover notes. Categories, keywords and priority rules are injected automatically from your handover section templates — keep the [[NOTES]] placeholder so notes can be inserted.",
      "editTitle": "Edit AI Prompt Template",
      "name": "Name",
      "description": "Description",
      "key": "Key",
      "template": "Prompt Template",
      "modelDeployment": "Model Deployment",
      "modelDeploymentPlaceholder": "e.g. gpt-4o (leave blank for default)",
      "modelDeploymentHint": "Azure OpenAI deployment name to use for this prompt. Blank uses the configured default.",
      "model": "Model",
      "modelDefault": "Default",
      "minConfidence": "Minimum Confidence",
      "placeholdersHint": "Placeholders: [[CATEGORIES]], [[KEYWORDS]], [[PRIORITY_RULES]], [[NOTES]] (classification) or [[CONTEXT]] (summary).",
      "notesPlaceholderRequired": "The template must contain the [[NOTES]] placeholder.",
      "placeholderRequired": "The template must contain the {{placeholder}} placeholder.",
      "restoreDefault": "Restore to Default",
      "restored": "Prompt restored to its default.",
      "restoredPreview": "Default prompt loaded — click Save to apply, or Cancel to discard.",
      "activeLabel": "Active",
      "active": "Active",
      "inactive": "Inactive",
      "status": "Status",
      "updated": "Last Updated",
      "saved": "AI prompt template saved.",
      "empty": "No AI prompt templates configured."
    },
    "roles": {
      "title": "System Roles",
      "create": "Create Role",
      "editTitle": "Edit Role",
      "name": "Name",
      "description": "Description",
      "permissions": "Permissions",
      "noPermissions": "No permissions enabled.",
      "generalSection": "General",
      "resources": {
        "Dashboard": "Dashboard",
        "OperationsItems": "Operations Items",
        "Execution": "Executions",
        "PlanningOptimizer": "Planning Optimizer",
        "DynamicRounds": "Dynamic Tasks",
        "Exceptions": "Exceptions",
        "ShiftComm": "Shift Notes",
        "Handover": "Handover Reports",
        "Shifts": "Shifts",
        "Ai": "AI Summaries",
        "Rounds": "Rounds",
        "Scheduling": "Scheduling",
        "ChangeMgmt": "Change Workbench",
        "Suspensions": "Round Suspensions",
        "Reporting": "Reports",
        "Users": "Users",
        "Roles": "System Roles",
        "Hierarchy": "Hierarchy",
        "OperationalPositions": "Operational Positions",
        "Equipment": "Equipment",
        "Crews": "Crews",
        "TenantSettings": "BU Settings",
        "Audit": "Audit Log",
        "Notifications": "Notifications",
        "Media": "Photos & Attachments"
      },
      "searchPermissionsPlaceholder": "Search by permission or group name...",
      "scope": "Scope",
      "global": "Global",
      "bu": "Business Unit",
      "system": "System Default",
      "empty": "No system roles found.",
      "clone": "Clone",
      "resetAction": "Reset",
      "created": "Role created.",
      "updated": "Role updated.",
      "cloned": "Role cloned.",
      "wasReset": "Role reset to defaults.",
      "deleted": "Role deleted."
    },
    "retention": {
      "title": "Data Retention",
      "hint": "Set retention periods per record type. Records are never deleted until a period is configured. Legal holds block all deletion.",
      "addPolicy": "Add Policy",
      "noPolicies": "No retention policies configured. All records are retained indefinitely (never delete).",
      "created": "Retention policy created.",
      "updated": "Retention policy updated.",
      "deleted": "Retention policy deleted.",
      "createTitle": "Create Retention Policy",
      "editTitle": "Edit Retention Policy",
      "neverDelete": "Never delete",
      "days": "days",
      "columns": {
        "entityType": "Record Type",
        "retention": "Retention",
        "legalHold": "Legal Hold"
      },
      "fields": {
        "entityType": "Record Type",
        "retentionDays": "Retention Period (days)",
        "retentionDaysHint": "Enter 0 to retain indefinitely (never delete).",
        "legalHold": "Legal hold active (blocks all deletion)"
      },
      "entityTypes": {
        "Execution": "ORD Execution Records",
        "HandoverRecord": "Shift Handover Records",
        "OperationalException": "Operational Exceptions",
        "ShiftLogEntry": "Shift Log Entries",
        "AuditEvent": "Audit Events",
        "Notification": "Notifications"
      }
    },
    "sweeps": {
      "title": "Scheduled Sweeps",
      "hint": "Background sweeps detect missed rounds, close shifts, raise escalations and generate schedules. If one stops running, the work it does simply never happens — check here before assuming a notification was never due.",
      "refresh": "Refresh",
      "noSweeps": "No sweeps are registered.",
      "never": "Never run",
      "staleAlert": "One or more sweeps have missed several expected runs. Their work is not being done until they run again.",
      "runNow": "Run now",
      "runWindow": "Run over window…",
      "ran": "Sweep finished. Processed {{processed}}, skipped {{skipped}}.",
      "ranWithFailures": "Sweep finished with errors. Processed {{processed}}, skipped {{skipped}}, failed {{failed}}.",
      "resultSummary": "Processed {{processed}} · skipped {{skipped}} · failed {{failed}}",
      "columns": {
        "name": "Sweep",
        "cadence": "Runs",
        "lastRun": "Last run",
        "lastResult": "Last result",
        "health": "Status"
      },
      "cadence": {
        "none": "Not scheduled",
        "minutes": "Every {{count}} minutes",
        "hours": "Every {{count}} hours",
        "days": "Every {{count}} days"
      },
      "health": {
        "healthy": "Healthy",
        "stale": "Overdue",
        "never": "Unknown",
        "failures": "Errors"
      },
      "names": {
        "missed-rounds": "Missed rounds",
        "shift-auto-close": "Shift auto-close",
        "escalation": "Escalations",
        "suspension-lifecycle": "Suspension lifecycle",
        "round-generation": "Round generation",
        "approval-overdue": "Overdue approvals",
        "revalidation-notice": "Revalidation notices"
      },
      "descriptions": {
        "missed-rounds": "Marks scheduled rounds missed once their window closes and raises an exception for each.",
        "shift-auto-close": "Closes shift instances left open past their grace period.",
        "escalation": "Escalates overdue exceptions, missed rounds and dynamic-round approvals.",
        "suspension-lifecycle": "Ends expired suspensions and sends the reminder and resume notices.",
        "round-generation": "Generates scheduled rounds across the configured horizon.",
        "approval-overdue": "Notifies approvers whose review has passed its SLA.",
        "revalidation-notice": "Warns owners of rounds approaching their revalidation date."
      },
      "confirmRun": {
        "title": "Run sweep now?",
        "message": "This runs “{{name}}” immediately over its normal window — the same work its schedule performs. Re-running over already-processed records does nothing."
      },
      "integrations": {
        "title": "Integrations",
        "hint": "Imports that bring work in from other systems. They run on the import host, so Run now asks it to start on its next check, within about five minutes.",
        "columns": {
          "name": "Integration"
        },
        "databricks": {
          "name": "Databricks activity import",
          "description": "Pulls Planning Optimizer activities from Databricks as simple tasks."
        },
        "resultSummary": "Received {{received}} · created {{created}} · skipped {{skipped}} · failed {{failed}}",
        "issue": "{{count}} × {{reason}}",
        "startedByRunNow": "Started by Run now",
        "lastSuccessful": "Last successful read {{time}}",
        "requestedAt": "Requested {{time}} — waiting for the import host",
        "requested": "Run requested. The import host starts it within about five minutes — refresh to see the result.",
        "health": {
          "off": "Switched off",
          "failed": "Failed"
        },
        "confirmRun": {
          "title": "Run the Databricks import now?",
          "message": "The import host starts it on its next check, within about five minutes. Activities already imported are skipped, so running early is safe."
        }
      },
      "runDialog": {
        "title": "Run {{name}} over a wider window",
        "hint": "Widening the look-back lets the sweep pick up records its normal window has already passed. Preview first — a wide window can send a large backlog of notifications at once.",
        "lookBackHours": "Look back (hours)",
        "lookBackHoursHint": "Between 1 and 720 hours (30 days).",
        "preview": "Preview",
        "run": "Run",
        "previewRequired": "Preview the window to see how many records would be affected before running.",
        "previewHeading": "{{count}} record(s) would be processed.",
        "previewConfirm": "Nothing has been changed yet. Select Run to execute over this window."
      }
    },
    "settings": {
      "title": "BU Settings",
      "hint": "Configure the behavior flags and thresholds that govern this business unit. Changes apply immediately to new activity.",
      "saved": "Settings saved.",
      "sections": {
        "handover": "Shift Handover",
        "execution": "Execution & Scheduling",
        "escalations": "Escalations",
        "localization": "Localization",
        "changeManagement": "Change Management"
      },
      "acknowledgementModes": {
        "Required": "Required",
        "AutoTimeout": "Auto-acknowledge after timeout",
        "None": "Not required"
      },
      "fields": {
        "handoverAcknowledgementMode": "Handover acknowledgement mode",
        "handoverAutoAcknowledgeTimeoutMinutes": "Auto-acknowledge timeout (minutes)",
        "roundGenerationHorizonHours": "Round generation horizon (hours)",
        "rotationLengthDays": "Rotation length (days)",
        "assetVerificationEnabled": "Asset verification enabled",
        "sosParticipantLoggingEnabled": "Start-of-shift participant logging enabled",
        "shiftCloseGracePeriodMinutes": "Default shift close grace period (minutes)",
        "shiftStartGracePeriodMinutes": "Default shift start grace period (minutes)",
        "handoverAckOperatorEnabled": "Operator handover acknowledgement required",
        "handoverAckConsoleOperatorEnabled": "Console Operator roll-up acknowledgement required",
        "handoverAckSupervisorEnabled": "Supervisor roll-up acknowledgement required",
        "exceptionCarryoverAgedThresholdShifts": "Exception carryover aged threshold (shifts)",
        "quickTaskEscalationEnabled": "Escalate missed quick tasks",
        "missedRoundEscalationEnabled": "Escalate missed rounds",
        "changeAutoClassificationEnabled": "Auto-classify change tiers",
        "minorChangeSlaHours": "Minor change approval SLA (hours)",
        "majorChangeSlaHours": "Major change approval SLA (hours)",
        "majorPublishNotifyWindowDays": "Major-change past-executor notify window (days)",
        "defaultLanguage": "Default language",
        "unitSystem": "Units of measure",
        "timeZoneId": "Default timezone",
        "timeZoneIdPlaceholder": "e.g. America/Chicago"
      },
      "hints": {
        "shiftCloseGracePeriodMinutes": "Default used by shifts that do not set their own close grace",
        "shiftStartGracePeriodMinutes": "How early or late an operator may clock in, for shifts that do not set their own start grace",
        "handoverAutoAcknowledgeTimeoutMinutes": "Only used when the acknowledgement mode is Auto-acknowledge after timeout",
        "quickTaskEscalationEnabled": "A missed {{pageName}} activity raises an exception, which escalates. When off, a note is added to the shift log instead. Turning it back on applies only to activities missed afterwards.",
        "missedRoundEscalationEnabled": "A missed round raises an exception and notifies the escalation chain. When off, a note is added to the shift log instead. Turning it back on applies only to rounds missed afterwards."
      },
      "languages": {
        "en": "English",
        "es": "Spanish (Español)",
        "pt": "Portuguese (Português)",
        "fr": "French (Français)",
        "ru": "Russian (Русский)",
        "kk": "Kazakh (Қазақша)",
        "nl": "Dutch (Nederlands)",
        "de": "German (Deutsch)",
        "zh-Hans": "Chinese, Simplified (简体中文)",
        "zh-Hant": "Chinese, Traditional (繁體中文)",
        "ja": "Japanese (日本語)",
        "ta": "Tamil (தமிழ்)",
        "ar": "Arabic (العربية)",
        "km": "Khmer (ខ្មែរ)",
        "ms": "Malay (Bahasa Melayu)",
        "fil": "Filipino",
        "th": "Thai (ไทย)",
        "si": "Sinhala (සිංහල)",
        "vi": "Vietnamese (Tiếng Việt)",
        "ur": "Urdu (اردو)"
      },
      "unitSystems": {
        "1": "Metric / SI (°C, kPa)",
        "2": "Imperial (°F, PSI)"
      }
    },
    "auditLog": {
      "title": "Audit Log",
      "hint": "Immutable, append-only record of every state-changing action in this business unit. Records cannot be edited or deleted.",
      "empty": "No audit events match the selected filters.",
      "filters": {
        "eventType": "Event Type",
        "entityType": "Record Type",
        "fromDate": "From",
        "toDate": "To",
        "all": "All",
        "apply": "Apply",
        "clear": "Clear"
      },
      "columns": {
        "timestamp": "Timestamp",
        "eventType": "Event",
        "entityType": "Record Type",
        "user": "User",
        "ipAddress": "IP Address"
      }
    },
    "correctiveActionPathRules": {
      "title": "Corrective-Action Path Rules",
      "hint": "Pre-select the corrective-action path for a reviewer based on exception severity. A rule with 'Any severity' is the BU-wide default. The reviewer can always override the pre-selected path.",
      "addRule": "Add Rule",
      "noRules": "No path rules configured. Reviewers choose the corrective-action path manually.",
      "created": "Path rule created.",
      "updated": "Path rule updated.",
      "deleted": "Path rule deleted.",
      "createTitle": "Create Path Rule",
      "editTitle": "Edit Path Rule",
      "anySeverity": "Any severity (default)",
      "columns": {
        "severity": "Exception Severity",
        "defaultPath": "Default Path",
        "active": "Active"
      },
      "fields": {
        "severity": "Exception Severity",
        "defaultPath": "Default Corrective-Action Path",
        "isActive": "Active"
      },
      "severities": {
        "1": "Low",
        "2": "Medium",
        "3": "High",
        "4": "Critical"
      },
      "paths": {
        "1": "Track Internally",
        "2": "Create Work Order (SAP/Maximo)"
      }
    },
    "platformAdmins": {
      "title": "Platform Administrators",
      "description": "Positions that carry an enterprise role grant administration across every Business Unit. They sit outside the location hierarchy, so they are listed here rather than under a node.",
      "position": "Position",
      "businessUnit": "Description",
      "roles": "Enterprise roles",
      "holders": "Held by",
      "noHolders": "Nobody",
      "empty": "No positions grant platform administration.",
      "total": "{{count}} people hold platform administration."
    },
    "hceRules": {
      "title": "HCE Verification Rules",
      "addRule": "Add Rule",
      "noRules": "No HCE rules configured.",
      "created": "HCE rule created.",
      "updated": "HCE rule updated.",
      "deleted": "HCE rule deleted.",
      "createTitle": "Create HCE Rule",
      "editTitle": "Edit HCE Rule",
      "any": "Any",
      "columns": {
        "priority": "Priority",
        "health": "Health",
        "criticality": "Criticality",
        "environment": "Environment",
        "verification": "Verification",
        "photo": "Photo",
        "supervisor": "Supervisor"
      },
      "fields": {
        "health": "Health Classification",
        "criticality": "Criticality Classification",
        "environment": "Environment Classification",
        "priority": "Priority (lower = first)",
        "requiresVerification": "Requires Asset Verification",
        "requiresPhoto": "Requires Photo Evidence",
        "requiresSupervisor": "Requires Supervisor Review"
      }
    },
    "unitsOfMeasure": {
      "title": "Units of Measure",
      "addUnit": "Add Unit",
      "noUnits": "No units of measure match the current filters.",
      "search": "Search symbol or description",
      "allGroups": "All groups",
      "showInactive": "Show inactive",
      "active": "Active",
      "inactive": "Inactive",
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "created": "Unit of measure created.",
      "updated": "Unit of measure updated.",
      "deactivated": "Unit of measure deactivated.",
      "reactivated": "Unit of measure reactivated.",
      "confirmDeactivate": "Deactivate ‘{{name}}’? It will be hidden from round authoring, but rounds that already use it keep working.",
      "createTitle": "Add Unit of Measure",
      "editTitle": "Edit Unit of Measure",
      "isActiveHint": "Inactive units are hidden from the round authoring picker.",
      "columns": {
        "symbol": "Symbol",
        "description": "Description",
        "group": "Group",
        "system": "Unit System",
        "status": "Status"
      },
      "fields": {
        "symbol": "Symbol",
        "description": "Description",
        "group": "Group",
        "system": "Unit System",
        "isActive": "Active"
      },
      "placeholders": {
        "symbol": "psi",
        "description": "pound per square inch",
        "group": "Pressure"
      },
      "systems": {
        "si": "SI",
        "imperial": "Imperial/US Customary",
        "nonSi": "Non-SI/Industry",
        "dimensionless": "Dimensionless",
        "mixed": "Mixed"
      }
    },
    "changeClassification": {
      "title": "Change Classification Rules",
      "hint": "Define how round changes are auto-classified as Minor or Major. Applied when auto-classification is enabled for this business unit.",
      "addRule": "Add Rule",
      "noRules": "No classification rules configured.",
      "created": "Classification rule created.",
      "updated": "Classification rule updated.",
      "deleted": "Classification rule deleted.",
      "createTitle": "Create Classification Rule",
      "editTitle": "Edit Classification Rule",
      "minor": "Minor",
      "major": "Major",
      "columns": {
        "scope": "Change Scope",
        "tier": "Resulting Tier",
        "active": "Active"
      },
      "fields": {
        "scope": "Change Scope",
        "tier": "Resulting Tier",
        "active": "Active"
      },
      "scopes": {
        "1": "Wording / clarification",
        "2": "Task added",
        "3": "Task removed",
        "4": "Acceptance criteria changed",
        "5": "Structure changed",
        "6": "Frequency changed",
        "7": "Operator response changed",
        "8": "Task basis / risk linkage changed",
        "9": "Critical Operator Task designation changed",
        "10": "Execution requirements changed",
        "11": "Task-round relationships changed"
      }
    },
    "changeRequestFields": {
      "title": "Change Request Fields",
      "hint": "Extra questions asked on the change request form, chosen per request type and shown in display order. Submitted requests keep a copy of each answer's question, so editing or deleting a field never changes a request already raised.",
      "addField": "Add Field",
      "noFields": "No custom fields yet — the change request form shows only its standard questions.",
      "created": "Field added.",
      "updated": "Field updated.",
      "deleted": "Field deleted.",
      "confirmDelete": "Delete the field \"{{label}}\"? New requests will no longer ask it; requests already raised keep their answer.",
      "createTitle": "Add Change Request Field",
      "editTitle": "Edit Change Request Field",
      "checkboxRequiredHint": "A required checkbox has to be ticked before the request can be submitted.",
      "activeHint": "Inactive fields are kept but not asked on new requests.",
      "columns": {
        "requestType": "Request Type",
        "label": "Question",
        "fieldType": "Control",
        "required": "Required",
        "sortOrder": "Order",
        "active": "Active"
      },
      "fields": {
        "requestType": "Request Type",
        "label": "Question",
        "fieldType": "Control",
        "dataType": "Accepts",
        "options": "Options",
        "sortOrder": "Display Order",
        "required": "Required",
        "active": "Active"
      },
      "fieldTypes": {
        "1": "Text box",
        "2": "Checkbox",
        "3": "Radio buttons",
        "4": "Dropdown"
      },
      "dataTypes": {
        "1": "Text",
        "2": "Number"
      },
      "options": {
        "label": "Label",
        "value": "Stored Value",
        "add": "Add Option",
        "remove": "Remove option",
        "hint": "The label is what the requestor sees; the stored value is saved with the request. Values must be unique within the field."
      }
    },
    "suspensions": {
      "title": "Round Suspensions",
      "hint": "Suspend individual rounds or every round under an area for a period. Suspended rounds are not generated and resume automatically when the suspension ends.",
      "empty": "No suspensions yet.",
      "emptyTab": "Nothing here.",
      "indefinite": "Indefinite",
      "endedLabel": "Ended",
      "bulkHint": "Every published round under the selected area will be suspended.",
      "endHint": "Leave empty for an indefinite suspension.",
      "created": "Suspension created.",
      "bulkCreated": "{{count}} rounds suspended.",
      "lifted": "Suspension lifted — the round will resume.",
      "confirmLift": "Lift this suspension and resume the affected round(s)?",
      "createTitle": "Suspend Rounds",
      "tabs": {
        "active": "Active",
        "scheduled": "Scheduled",
        "ended": "Ended"
      },
      "columns": {
        "scope": "Scope",
        "round": "Round",
        "window": "Window",
        "reason": "Reason"
      },
      "fields": {
        "scope": "Scope",
        "round": "Round",
        "hierarchyNode": "Area",
        "startAt": "Start",
        "endAt": "End",
        "reason": "Reason"
      },
      "scopes": {
        "1": "Single round",
        "2": "Task",
        "3": "Area (bulk)"
      },
      "actions": {
        "create": "Suspend",
        "suspend": "Suspend",
        "lift": "Lift"
      }
    },
    "shiftConfig": {
      "title": "Shift Configuration",
      "empty": "No shift patterns configured.",
      "addShift": "Add Shift",
      "created": "Shift created.",
      "updated": "Shift updated.",
      "deleted": "Shift deleted.",
      "createTitle": "Create Shift",
      "editTitle": "Edit Shift",
      "active": "Active",
      "inactive": "Inactive",
      "columns": {
        "name": "Name",
        "pattern": "Pattern",
        "startTime": "Start Time",
        "endTime": "End Time",
        "status": "Status",
        "assignments": "Assignments"
      },
      "fields": {
        "name": "Shift Name",
        "pattern": "Recurrence Pattern",
        "patternPlaceholder": "e.g., Day, Night, Swing",
        "startTime": "Start Time",
        "endTime": "End Time",
        "startGracePeriodMinutes": "Start grace (minutes)",
        "closeGracePeriodMinutes": "Close grace (minutes)",
        "isActive": "Active"
      },
      "hints": {
        "graceInherits": "Leave blank to inherit the Business Unit default."
      }
    },
    "crews": {
      "title": "Crews",
      "empty": "No crews configured yet.",
      "addCrew": "Add Crew",
      "create": "Create Crew",
      "edit": "Edit Crew",
      "created": "Crew created.",
      "updated": "Crew updated.",
      "deleted": "Crew deleted.",
      "onThisDay": "Crews on shift:",
      "active": "Active",
      "inactive": "Inactive",
      "columns": {
        "name": "Name",
        "status": "Status"
      },
      "fields": {
        "name": "Crew Name",
        "namePlaceholder": "e.g., Crew A",
        "color": "Color",
        "active": "Active"
      }
    },
    "rotation": {
      "title": "Rotation Schedule",
      "viewCalendar": "View Calendar",
      "saved": "Rotation schedule saved.",
      "saveFailed": "Could not save the rotation schedule. Check the configuration and try again.",
      "fields": {
        "name": "Schedule Name",
        "anchorDate": "Anchor Date"
      },
      "shifts": {
        "title": "Shift Windows",
        "add": "Add Shift",
        "addTitle": "Add Shift Window",
        "editTitle": "Edit Shift Window",
        "empty": "Add at least one shift window (e.g., Day, Night).",
        "name": "Name",
        "namePlaceholder": "e.g., Day, Night",
        "start": "Start",
        "end": "End",
        "unnamed": "Shift"
      },
      "blocks": {
        "title": "Rotation Blocks",
        "add": "Add Block",
        "empty": "Add blocks to define the rotation cycle.",
        "block": "Block {{index}}",
        "lengthDays": "Length (days)",
        "cycleLength": "Cycle: {{days}} days",
        "off": "Off",
        "addTitle": "Add Rotation Block",
        "editTitle": "Edit Rotation Block",
        "crewAssignments": "Crew Assignments"
      },
      "calendar": {
        "editRotation": "Edit Rotation",
        "previous": "Previous month",
        "next": "Next month",
        "empty": "No rotation configured for this period.",
        "weekdays": {
          "sun": "Sun",
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat"
        }
      }
    },
    "equipment": {
      "title": "Equipment Management",
      "treeTitle": "Hierarchy Tree",
      "noNodes": "No hierarchy nodes found.",
      "addEquipment": "Add Equipment",
      "noEquipment": "No equipment records found.",
      "selectNode": "Select a location to view equipment.",
      "filterByNode": "Filter by Location",
      "allNodes": "All Locations",
      "created": "Equipment created.",
      "updated": "Equipment updated.",
      "activated": "Equipment activated.",
      "deactivated": "Equipment deactivated.",
      "confirmDeactivate": "Are you sure you want to deactivate this equipment?",
      "confirmActivate": "Are you sure you want to activate this equipment?",
      "createTitle": "Add Equipment",
      "editTitle": "Edit Equipment",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "search": {
        "label": "Search assets",
        "placeholder": "Name, tag, description, or location",
        "noResults": "No assets match your search.",
        "resultsHint": "Showing {{count}} matching assets across all locations (max 50).",
        "addDisabled": "Clear the search to add an asset to the selected location."
      },
      "columns": {
        "tag": "Equipment Tag",
        "name": "Name",
        "assetClass": "Asset Class",
        "location": "Location",
        "type": "Type",
        "lastEdited": "Last Edited",
        "status": "Status"
      },
      "fields": {
        "tag": "Equipment Tag",
        "tagPlaceholder": "e.g., P-101A",
        "name": "Display Name",
        "namePlaceholder": "e.g., Main Feed Pump A",
        "description": "Description",
        "assetClass": "Asset Class",
        "assetClassPlaceholder": "e.g., Pump, Valve, Compressor",
        "equipmentType": "Equipment Type",
        "noEquipmentType": "None",
        "inactiveType": "{{name}} (inactive)",
        "location": "Hierarchy Location",
        "locationPath": "Location Path",
        "locationPathPlaceholder": "e.g., Site > Plant > Area > Unit",
        "nfcTagId": "NFC Tag ID",
        "qrCode": "QR Code",
        "barcode": "Barcode",
        "bleIdentifier": "BLE Identifier",
        "externalSystemId": "External System ID",
        "externalSystemType": "External System Type",
        "externalSystemTypePlaceholder": "e.g., SAP, Maximo",
        "isActive": "Active"
      },
      "sections": {
        "identification": "Identification Methods",
        "externalSystem": "External System Integration"
      }
    },
    "crewsRotation": {
      "title": "Crews & Rotation"
    }
  },
  "myRounds": {
    "title": "My Rounds",
    "filters": {
      "all": "All"
    },
    "status": {
      "notStarted": "Not started",
      "inProgress": "In progress",
      "paused": "Paused",
      "completed": "Completed"
    },
    "searchPlaceholder": "Search round, location or equipment",
    "groupByLocation": "Group by location",
    "scope": {
      "label": "Whose rounds",
      "mine": "My rounds",
      "all": "All rounds"
    },
    "loadError": "Your rounds could not be loaded.",
    "empty": "No rounds for your position right now.",
    "emptyDetail": "Rounds appear here when their window opens for the position you have selected.",
    "noSearchResults": "No rounds match your search.",
    "noLocation": "No location",
    "fieldTest": "Field test",
    "overdue": "Overdue",
    "criticalTasks": "{{count}} critical",
    "alertTasks": "{{count}} in alert",
    "due": "Due {{date}}",
    "estDuration": "Est. {{min}} min",
    "actualDuration": "Took {{min}} min",
    "progress": "{{done}} of {{total}} tasks",
    "skipped": "{{count}} skipped",
    "startedBy": "Started by {{name}}",
    "review": {
      "Approved": "Approved",
      "Flagged": "Flagged",
      "RequiresAction": "Requires action"
    },
    "continue": "Continue",
    "details": {
      "title": "Round details",
      "notFound": "This round is no longer on your list.",
      "location": "Location",
      "window": "Window",
      "due": "Due",
      "estimated": "Estimated",
      "actual": "Actual",
      "startedBy": "Started by",
      "equipment": "Equipment",
      "tasks": "Tasks",
      "answered": "Answered",
      "skipped": "Skipped",
      "notAnswered": "Not answered",
      "notes": "Round notes",
      "shareNotes": "Share with Shift Communication",
      "notesAfterStart": "Notes can be added once the round is started.",
      "notesSaveError": "Your notes could not be saved.",
      "start": "Start round",
      "view": "View round",
      "startError": "The round could not be started.",
      "notOpenYet": "This round's window has not opened yet.",
      "windowClosed": "This round's window has closed.",
      "progressTitle": "Tasks progress",
      "version": "Version",
      "started": "Started",
      "description": "Description",
      "viewResults": "View results"
    },
    "execution": {
      "saveError": "Your change could not be saved.",
      "photoType": "Only JPEG or PNG photos can be attached.",
      "photoTooLarge": "Photos must be 5 MB or smaller.",
      "uploadError": "The photo could not be uploaded.",
      "completed": "Round completed.",
      "confirmSkippedRequired": "Some required tasks were skipped. Complete the round anyway?",
      "confirmOutOfRange": "Some readings are outside their acceptable range. Complete the round anyway?",
      "confirmReopen": "Reopen this round so its answers can be changed?",
      "addPhoto": "Add photo",
      "skippedReason": "Skipped: {{reason}}",
      "skipReasonPlaceholder": "Why is this task being skipped?",
      "skip": "Skip",
      "unskip": "Undo skip",
      "notes": "Notes",
      "notesPlaceholder": "Add a note for this task",
      "shareToShiftComm": "Share with Shift Communication"
    },
    "roundsHeading": "Rounds",
    "view": {
      "label": "Layout",
      "list": "List",
      "byLocation": "By location"
    },
    "scheduled": "Scheduled: {{date}}",
    "taskCount": "{{count}} tasks",
    "completedCount": "{{done}}/{{total}} completed",
    "minutes": "{{min}} min"
  },
  "enums": {
    "roundStatus": {
      "Draft": "Draft",
      "UnderReview": "Under Review",
      "Approved": "Approved",
      "Published": "Published",
      "Retired": "Retired",
      "Suspended": "Suspended",
      "ValidationReview": "Validation Review"
    },
    "changeRequestStatus": {
      "Draft": "Draft",
      "Submitted": "Submitted",
      "UnderReview": "Under Review",
      "Approved": "Approved",
      "Rejected": "Rejected",
      "Implemented": "Implemented",
      "Cancelled": "Cancelled",
      "Classified": "Classified",
      "Returned": "Returned"
    },
    "changeRequestKind": {
      "Add": "Add",
      "Change": "Change",
      "Archive": "Archive",
      "Suspend": "Suspend",
      "NewRound": "New Round"
    },
    "approvalStageStatus": {
      "Pending": "Pending",
      "Active": "Active",
      "Completed": "Completed",
      "Skipped": "Skipped"
    },
    "approvalDecision": {
      "Approve": "Approve",
      "Reject": "Reject",
      "Return": "Return",
      "Recommend": "Recommend",
      "RecommendAgainst": "Recommend Against",
      "Abstain": "Abstain",
      "Screened": "Screened"
    },
    "approvalStageKind": {
      "Advisory": "Advisory",
      "FinalAuthority": "Final Authority",
      "Screening": "Screening",
      "Implementation": "Implementation",
      "ValidationReview": "Validation Review"
    },
    "executionStatus": {
      "NotStarted": "Not Started",
      "InProgress": "In Progress",
      "Paused": "Paused",
      "Completed": "Completed",
      "Missed": "Missed",
      "Cancelled": "Cancelled"
    },
    "reviewStatus": {
      "Approved": "Approved",
      "Flagged": "Flagged",
      "RequiresAction": "Requires Action"
    },
    "shiftStatus": {
      "Scheduled": "Scheduled",
      "Active": "Active",
      "HandoverPending": "Handover Pending",
      "Closed": "Closed"
    },
    "scheduleType": {
      "TimeBased": "Time-Based",
      "OnDemand": "On-Demand",
      "Campaign": "Campaign",
      "Dynamic": "Dynamic / Ad-hoc"
    },
    "triggerSource": {
      "Manual": "Manual",
      "Alarm": "Alarm",
      "EAM": "EAM",
      "Safety": "Safety"
    },
    "exceptionSeverity": {
      "Low": "Low",
      "Medium": "Medium",
      "High": "High",
      "Critical": "Critical"
    },
    "correctiveActionStatus": {
      "Open": "Open",
      "InProgress": "In Progress",
      "Completed": "Completed",
      "Verified": "Verified"
    },
    "accessRequestStatus": {
      "Pending": "Pending",
      "Approved": "Approved",
      "Rejected": "Rejected",
      "Cancelled": "Cancelled"
    },
    "hierarchyLevel": {
      "Enterprise": "Enterprise",
      "BU": "BU",
      "Site": "Site",
      "Area": "Area",
      "Unit": "Unit"
    },
    "taskType": {
      "Inspection": "Inspection",
      "Reading": "Reading",
      "Verification": "Verification",
      "DataEntry": "Data Entry",
      "Acknowledgement": "Acknowledgement",
      "PhotoCapture": "Photo Capture",
      "Signature": "Signature",
      "Container": "Group",
      "Alert": "Alert",
      "Message": "Message",
      "Expression": "Expression"
    },
    "sourceEntityType": {
      "Execution": "Execution",
      "Exception": "Exception",
      "CorrectiveAction": "Corrective Action",
      "Round": "Round",
      "ChangeRequest": "Change Request",
      "DynamicRoundRequest": "Dynamic Round Request",
      "Suspension": "Suspension",
      "WorkRequest": "Work Request",
      "ShiftLogEntry": "Shift Log Entry"
    },
    "notificationType": {
      "Escalation": "Escalation",
      "Approval": "Approval",
      "Assignment": "Assignment",
      "Reminder": "Reminder",
      "SystemAlert": "System Alert",
      "RoundAssigned": "Round Assigned",
      "ExceptionRaised": "Exception Raised",
      "EscalationAlert": "Escalation Alert",
      "HandoverPending": "Handover Pending",
      "ExecutionOverdue": "Execution Overdue",
      "CorrectiveActionDue": "Corrective Action Due",
      "RevalidationDue": "Revalidation Due",
      "ApprovalOverdue": "Approval Overdue",
      "RoundUpdated": "Round Updated",
      "DynamicRoundApprovalPending": "Dynamic Round Approval Pending",
      "DynamicRoundApproved": "Dynamic Round Approved",
      "ShiftNoteMention": "Shift Note Mention",
      "ChangeRequestReturned": "Change Request Returned",
      "ChangeRequestApproved": "Change Request Approved",
      "SuspensionEnded": "Suspension Ended",
      "ChangeRequestWithdrawn": "Change Request Withdrawn",
      "ChangeRequestRejected": "Change Request Rejected",
      "ChangeRequestImplemented": "Change Request Implemented"
    },
    "cooStatus": {
      "Compliant": "Compliant",
      "NonCompliant": "Non-Compliant"
    }
  }
}
